<template>
  <div>
    <div class="content-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input :key="'searchtxt'" icon-pack="feather" icon="icon-search" v-model="searchtxt" placeholder="Search by Name/Email/Phone"
            class="is-label-placeholder" />
        </div>
      </div>
      <div class="content-header-right">
        <!--filter dropdown-->
        <vs-inv-dropdown >
        <!-- <vs-dropdown vs-custom-content vs-trigger-click>
          <vs-button color="primary" class="filter-btn" type="border" icon-pack="feather" icon="icon-chevron-down"
            icon-after>
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button> -->
          <!-- <vs-dropdown-menu ref="filter_menu" class="filters-content"> -->
           <div class="filters-content"> 
            <div class="filters-form-fileds noscroll">
              <div class="form-container">
                <div class="vx-row">

                  <div class="vx-col md:w-1/3 w-full con-select" v-if="[3].indexOf(getUserRoleId) > -1">
                    <label class="typo__label">Select Branch</label>
                    <multiselect v-model="filterBranch" :options="branchList" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Branch" label="name" track-by="name" :preselect-first="false">

                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                          Branch(s) selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>
                  </div>

                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Roles</label>
                    <multiselect v-model="filter_roleIds" :options="all_userroles" :multiple="true" :hideSelected="true"
                      :close-on-select="false" :clear-on-select="false" :select-label="''" :preserve-search="true"
                      placeholder="Select Roles" label="name" track-by="name" :preselect-first="false">
                      <!-- <template slot="selection" slot-scope="{ values,  isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                          options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                          Role(s) selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Status</label>

                    <multiselect v-model="selected_statusids" :options="all_statusids" :multiple="true"
                      :hideSelected="true" :close-on-select="false" :clear-on-select="false" :select-label="''"
                      :preserve-search="true" placeholder="Select Status" label="name" track-by="name"
                      :preselect-first="false">

                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Status
                          selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker :maxDate="new Date()" :autoApply="autoApply" :ranges="false" :opens="'right'"
                      v-model="selected_createdDateRange"></date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons">

              </div>
              <div class="right-buttons">
                <vs-button color="success" class="save" type="filled" vs-trigger-click
                  v-on:click="set_filter()">Apply</vs-button>
                <vs-button color="dark" class="cancel" type="filled" vs-trigger-click
                  v-on:click="clear_filter($event)">Clear
                </vs-button>
              </div>
            </div>
          </div>
          <!-- </vs-dropdown-menu> -->
        <!-- </vs-dropdown> -->
      </vs-inv-dropdown>
        <!-- end -->
        <vs-button type="border" v-if="[2].indexOf(getUserRoleId) < 0" class="light-blue-btn"
          @click="inviteUserPopupshow(true)">Invite User <span>
            <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
          </span>
        </vs-button>

        <!-- <button class="btn btn-brown" @click="FillingFreeDetails=true">Filling</button> -->
      </div>
    </div>

    <NoDataFound ref="NoDataFoundRef" :loading="!contentLoaded" v-if="users.length == 0" content=""
      :heading="callFromSerch ? 'No Results Found' : 'You haven\'t  created any Users yet. Create a Users to start using the ImmiBox'"
      type='Users' />

    <div class="accordian-table customtable" v-if="users.length > 0">
      
      <vs-table :data="users" :no-data-text="'No data found..!'">
        <template slot="thead" v-if="users.length > 0">
          <vs-th>
            <a @click="sortMe('name')"
              v-bind:class="{ 'sort_ascending': sortKeys['name'] == 1, 'sort_descending': sortKeys['name'] != 1 }">
              Name
            </a>
          </vs-th>
          <vs-th v-if="[3].indexOf(getUserRoleId) > -1"> Branch(s)

          </vs-th>
          <vs-th>
            <a @click="sortMe('email')"
              v-bind:class="{ 'sort_ascending': sortKeys['email'] == 1, 'sort_descending': sortKeys['email'] != 1 }">
              Email
            </a>
          </vs-th>

          <vs-th>
            <a @click="sortMe('phone')"
              v-bind:class="{ 'sort_ascending': sortKeys['phone'] == 1, 'sort_descending': sortKeys['phone'] != 1 }">
              Phone Number
            </a>
          </vs-th>
          <!-- <vs-th>
            <a @click="sortMe('roleName')"  v-bind:class="{'sort_ascending':sortKeys['roleName']==1, 'sort_descending':sortKeys['roleName']!=1}" >
             User Role
              </a>
          
          </vs-th> -->
          <vs-th>
            <a @click="sortMe('statusName')"
              v-bind:class="{ 'sort_ascending': sortKeys['statusName'] == 1, 'sort_descending': sortKeys['statusName'] != 1 }">
              Status
            </a>
          </vs-th>
          <vs-th>
            <a @click="sortMe('createdOn')"
              v-bind:class="{ 'sort_ascending': sortKeys['createdOn'] == 1, 'sort_descending': sortKeys['createdOn'] != 1 }">
              Created On
            </a>
          </vs-th>
          <vs-th class="actions">Actions</vs-th>

        </template>

        <template slot-scope="{data}">
          <template>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.name">

                <figure class="dp_img"><img class="user-image" :src="checkProperty(tr, 'profilePicture')"
                    @error="setDefaultPhoto($event, '', type = 'user')" /></figure>
                <div>
                  {{ tr.name }} <br />
                  <span class="user_role">
                    {{ checkProperty(tr, 'roleDetails', "name") }}
                  </span>
                </div>
                <!-- <a href="">{{tr.name}}</a> -->
              </vs-td>

              <!-- <vs-td v-if="[3].indexOf(getUserRoleId) > -1"> {{ checkProperty(tr, 'branchDetails', "name") }}</vs-td> -->
              <vs-td v-if="[3].indexOf(getUserRoleId) > -1"> 
                <template v-if="checkProperty(tr, 'branchesList', 'length') > 0">
                  {{ tr.branchesList[0] }}
                </template>

                <div class="menu_dropdown flexible_actions email_list right ml-2"
                  v-if="checkProperty(tr, 'branchesList', 'length') > 1">
                  <em class="more_count ">
                    +{{ tr['branchesList'].length - 1 }}
                  </em>
                  <div class="menu_list_wrap" v-if="checkProperty(tr, 'branchesList', 'length') > 1">
                    <ul class="">
                      <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--main-sidebar" :settings="settings"
                        @ps-scroll-y="psSectionScroll">
                        <template v-for="( name, eind ) in tr['branchesList']">
                          <li v-if="eind > 0" :key="eind">{{ name }}</li>
                        </template>

                      </VuePerfectScrollbar>

                    </ul>

                  </div>
                </div>
                </vs-td>
              <vs-td> {{ checkProperty(tr, 'email') }}</vs-td>
              <vs-td>
                <span>



                  <template v-if="checkProperty(tr, 'phoneCountryCode', 'countryCallingCode')">{{ checkProperty(tr
                    , 'phoneCountryCode', 'countryCallingCode') + "&nbsp;" }}</template> {{ checkProperty(tr, 'phone') }}



                </span>
              </vs-td>
              <!-- <vs-td >
              <span >
              {{checkProperty(tr ,'roleDetails' ,"name")}} 
              </span>
            </vs-td> -->
              <vs-td>
                <span class="statusspan "
                  :class="{ 'status_pending': tr.statusId == 1, 'status_active': tr.statusId == 2, 'status_inactive': tr.statusId == 3, 'status_rejected': tr.statusId == 4 }">
                  {{ checkProperty(tr, "statusDetails", 'name') }}
                </span>
              </vs-td>

              <vs-td>
                <span>
                  {{ tr['createdOn'] | formatDate }}

                </span>
              </vs-td>

              <vs-td :data="tr.statusId">

                <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true" v-if="
                  true || (
                    (tr.statusId != 1 && [3, 4].indexOf(getUserRoleId) > -1 && (tr._id != checkProperty(getUserData, 'userId')))
                    || (tr.statusId == 1 && (tr._id != checkProperty(getUserData, 'userId')))
                    || ([1].indexOf(tr.roleId) <= -1) && (tr._id != checkProperty(getUserData, 'userId')) && ([1].indexOf(tr['roleId']) < 0) && (tr.statusId == 2 || tr.statusId == 3)
                  )">
                  <a class="a-icon" href.prevent><more-vertical-icon size="1.5x"
                      class="custom-class"></more-vertical-icon></a>
                  <vs-dropdown-menu class="loginx msg_dropdown">
                    <vs-dropdown-item v-if="(tr.statusId == 1 && (tr._id != checkProperty(getUserData, 'userId')))">
                      <a href="#">
                        <p style="cursor:pionter" @click="selectedItem = tr; resend(tr)">Resend Activation Link </p>
                      </a>
                    </vs-dropdown-item>

                    <!-- <vs-dropdown-item v-if="([1].indexOf(tr.roleId) <=-1) && ( tr._id !=checkProperty(getUserData,'userId') ) && ( [1].indexOf(tr['roleId']) <0) && ( tr.statusId==2 || tr.statusId==3 )">
                     <a href="#" v-if="tr.statusId==2 || tr.statusId==3"><p style="cursor:pionter" @click="openactiveConform(tr)" >
                       <template v-if="tr.statusId==2  && tr._id !=checkProperty(getUserData,'userId')">Inactive</template>
                        <template v-if="(tr.statusId==1 || tr.statusId==3) "> Activate</template></p>
                      </a>
                  </vs-dropdown-item> -->
                    <vs-dropdown-item v-if="[3].indexOf(getUserRoleId) > -1 && tr.statusId == 2 && tr.statusId != 3">
                      <a href="#">
                        <p style="cursor:pionter" @click="openactiveConform(tr, 3)">Inactive</p>
                      </a>
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="[3].indexOf(getUserRoleId) > -1 && tr.statusId == 3 && tr.statusId != 2">
                      <a href="#">
                        <p style="cursor:pionter" @click="openactiveConform(tr, 2)">Activate</p>
                      </a>
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="[3].indexOf(getUserRoleId) > -1 && tr.statusId != 4">
                      <a href="#">
                        <p style="cursor:pionter" @click="openactiveConform(tr, 4)">Delete</p>
                      </a>
                    </vs-dropdown-item>

                    <vs-dropdown-item
                      v-if="(tr.statusId != 1 && [3, 4, 7].indexOf(getUserRoleId) > -1 && (tr._id != checkProperty(getUserData, 'userId')) && tr.statusId != 3 && tr.statusId != 4)">
                      <a href="#">
                        <p style="cursor:pionter" @click="selectedItem = tr; openSetPasswordPopup(tr)">Set Password</p>
                      </a>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <a>
                        <p style="cursor:pionter" @click="selectedItem = tr; showDetails(tr)">User Details</p>
                      </a>
                    </vs-dropdown-item>

                    <template
                      v-if="((([1].indexOf(getUserRoleId) > -1 && [2].indexOf(tr['roleId']) > -1) || ([3].indexOf(getUserRoleId) > -1 && [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].indexOf(tr['roleId']) > -1) && tr.statusId != 3 && tr.statusId != 4))">
                      <vs-dropdown-item>
                        <a>
                          <p style="cursor:pionter" @click="selectedItem = tr; editMe(tr)">Edit</p>
                        </a>
                      </vs-dropdown-item>
                    </template>
                    <template v-if="(([7, 8].indexOf(tr['roleId']) > -1) && false)">
                      <vs-dropdown-item>
                        <a>
                          <p style="cursor:pionter" @click="selectedItem = tr; showAssignPetitioner(tr)">Assign Petitioner
                          </p>
                        </a>
                      </vs-dropdown-item>
                    </template>
                    <vs-dropdown-item v-if="[3].indexOf(getUserRoleId)>-1 && showMfaAction">
                      <a>
                        <p style="cursor:pionter" @click="selectedItem = tr;showMFAPopup = true">Multi-Factor Authentication</p>
                      </a>
                    </vs-dropdown-item>
                    <!-- <template
                    v-if="[3].indexOf(getUserRoleId)>-1&& checkProperty(tr,'deleteMyProfile') ==true"
                    >
                      <vs-dropdown-item>
                        <a>
                          <p style="cursor:pionter" @click="showRevertAction(tr)">Recover Profile</p>
                        </a>
                      </vs-dropdown-item>
                    </template> -->

                  </vs-dropdown-menu>


                </vs-dropdown>
                <a v-else class="a-icon" href.prevent><more-vertical-icon size="1.5x"
                    class="custom-class disbleMenu"></more-vertical-icon></a>

              </vs-td>


            </vs-tr>
          </template>
        </template>
      </vs-table>
      <div class="table_footer">
        <div class="vx-col  con-select pages_select"  v-if="users.length>0">
          <label class="typo__label">Per Page</label>
          <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true" :allow-empty="false">
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
          <paginate v-if="users.length > 0" v-model="page" :page-count="totalpages" :page-range="3" :margin-pages="2"
        :click-handler="pageNate" prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
        :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'"></paginate>
      </div>
      
    </div>


    <vs-popup class="holamundo main-popup" :title="popUpTitle" :active.sync="approveConformpopUp">
      <!-- (checkProperty(selectedUser,'statusId') ==2?'Inactivate ':' Activate')+' User' -->
      <div class="form-container">

        <div class="vx-row">
          <div class="vx-col w-full">
            <!-- <p>Are you sure of {{checkProperty(selectedUser,'statusId') ==2?'inactivating':'activating '}} this User?</p> -->
            <!-- <p>{{ popUpText }}</p> -->
            <p>Are you sure to continue?</p>
          </div>

        </div>

        <div v-show="formerrors.msg">
          <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
            icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
        </div>

      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="approveConformpopUp = false">Cancel </vs-button>
        <!-- <vs-button color="success" class="save" type="filled" @click="toggleActivate(selectedUser)">{{checkProperty(selectedUser,'statusId')==2?'Inactivate ':' Activate'}}</vs-button> -->
        <vs-button v-if="selectedStatus == 2" color="success" class="save" :disabled="loading" type="filled"
          v-on:click.stop.prevent="toggleActivate(2)">
          Activate
        </vs-button>
        <vs-button v-else-if="selectedStatus == 4 && !hideInactive" color="success" class="save" :disabled="loading" type="filled"
          v-on:click.stop.prevent="toggleActivate(4)">
          Delete
        </vs-button>
        <vs-button v-else-if="selectedStatus == 3 && !hideInactive" color="success" class="save" :disabled="loading" type="filled"
          v-on:click.stop.prevent="toggleActivate(3)">
          Inactivate
        </vs-button>
      </div>
    </vs-popup>


    <vs-popup class="holamundo main-popup" title="Set Password" :active.sync="SetPassword">
      <form @submit.prevent>
        <div class="popup-accounts-content edit_password" v-if="SetPassword" @click="setPasswordErrorMsg = ''">

          <div class="form-container padb0">
            <div class="form_group">
              <!-- <i class="placeholder-icon IP-hide-1"></i> -->
              <label class="form_label">New Password<em>*</em></label>
              <vs-input :key="'currentPassword'" type="password" v-validate="'required|min:6|max:15|strongpassword'" data-vv-as="New Password"
                name="currentPassword" v-model="newPassword" class="w-full no-icon-border" ref="password" />
              <span class="text-danger text-sm" v-show="errors.has('currentPassword')">{{ errors.first("currentPassword")
              }}<br /></span>
            </div>
            <div class="form_group">
              <!-- <i class="placeholder-icon IP-hide-1"></i> -->
              <label class="form_label">Confirm Password<em>*</em></label>
              <vs-input :key="'newPassword'" type="password" v-validate="'required|confirmed:password'" data-vv-as="Confirm Password"
                v-model="confPassword" name="newPassword" class="w-full no-icon-border" />
              <span class="text-danger text-sm" v-show="errors.has('newPassword')">{{
                errors.first("newPassword")
              }}</span>
            </div>
            <div v-if="setPasswordErrorMsg">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                icon="IP-information-button" active="true">{{ setPasswordErrorMsg }}</vs-alert>
            </div>
          </div>
          <div class="popup-footer justify-between relative">
            <div class="password-count">
              <i class="icon IP-lock"></i> Password must contain 6 to 15 characters
            </div>
            <div class="d-flex">
              <vs-button color="dark" @click="SetPassword = false ; updatingPassword = false" class="cancel"
                type="filled">Cancel</vs-button>

              <vs-button class="save" type="filled" @click="changePassword" :disabled="updatingPassword">
                <figure v-if="updatingPassword" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
                Update
              </vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>

    <!---
    <vs-popup class="holamundo main-popup" title="" v-if="addNewUser" :active.sync="addNewUser">
     
    </vs-popup>
    -->

    <modal name="inviteUserPopupModal" classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
      :reset="true" width="750px" height="auto">
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">
            <template v-if="isUserEdit">Edit User </template>
            <template v-else> Invite User</template>

          </h2>
          <span @click="inviteUserPopupshow(false); $modal.hide('inviteUserPopupModal'); addNewUser = false;altCheck = false;altEmailForForms='';errorMsg=''">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form>
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <div class="form_group">
                  <label class="form_label">First Name<em>*</em></label>
                  <vs-input :key="'firstname'" v-model="new_user.firstname" name="firstname" v-validate="'required'" class="w-full"
                    data-vv-as="First Name" />
                  <span class="text-danger text-sm" v-show="errors.has('firstname')">{{ errors.first("firstname")
                  }}</span>
                </div>
              </div>
              <div class="vx-col w-1/2">
                <div class="form_group">
                  <label class="form_label">Last Name<em>*</em></label>
                  <vs-input :key="'lastname'" v-model="new_user.lastname" name="lastname" v-validate="'required'" class="w-full"
                    data-vv-as="Last Name" />
                  <span class="text-danger text-sm" v-show="errors.has('lastname')">{{ errors.first("lastname") }}</span>
                </div>
              </div>
              <div class="vx-col w-1/2">
                <div class="form_group">
                  <label class="form_label">Email<em>*</em></label>
                  <vs-input :key="'email'" :disabled="isUserEdit && [3].indexOf(getUserRoleId) <= -1" class="w-full" name="email"
                    v-model="new_user.email" v-validate="'required|email'" data-vv-as="Email" />
                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
                </div>
              </div>
              <div class="vx-col w-1/2" v-if="[3].indexOf(getUserRoleId) > -1">
                <div class="form_group multi_zindex">
                  <div class="con-select w-full">
                    <label for class="vs-select--label">Branch<em>*</em></label>
                    <!-- :disabled="isUserEdit" -->
                    <multiselect  v-model="selectedBranch"  :options="branchList" :multiple="true" :hideSelected="true"
                      v-validate="'required'" :close-on-select="false" :clear-on-select="false" :select-label="''"
                      :preserve-search="true" placeholder="Select Branch" name="branch" data-vv-as="Branch" label="name"
                      track-by="_id" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values,  isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                          option(s) selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>
                  </div>
                  <span class="text-danger text-sm" v-show="errors.has('branch')">{{ errors.first("branch") }}</span>
                </div>
              </div>
              <div class="vx-col "
                :class="{ 'w-1/2': ([3].indexOf(getUserRoleId) > -1), 'w-full': ([3].indexOf(getUserRoleId) <= -1) }">
                <div class="form_group">
                  <label for class="form_label">User Role<em>*</em></label>
                  <div class="con-select w-full">


                    <multiselect :disabled="checkUserRoleDisable" class="w-full" v-model="selected_roleID"
                      placeholder="Select User Role" name="selected_userrole" data-vv-as="User Role" @input="roleChanged"
                      v-validate="'required'" deselect-label="Can't remove this value" track-by="name" label="name"
                      :options="all_userroles" :searchable="false" :allow-empty="false">
                      <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong> </template>
                    </multiselect>
                  </div>
                  <span class="text-danger text-sm" v-show="errors.has('selected_userrole')">{{
                    errors.first("selected_userrole") }}</span>
                </div>
              </div>
              <div class="vx-col w-1/2">
                <div class="form_group ph_number">
                  <label for="" class="form_label">Phone Number<em>*</em></label>
                  <div class="vs-component">

                    <VuePhoneNumberInput icon-pack="feather" class="w-full no-icon-border" :no-example="false"
                      v-validate="'required'" name="phone" key="phone" data-vv-as="Phone Number" v-bind="vuePhone.props"
                      :default-country-code="countryCode" :no-country-selector="false" v-model="new_user.phone"
                      @update="updatePhone" :preferred-countries="['US', 'IN']" />

                  </div>
                  <span class="text-danger text-sm" v-show="!isPhoneValid && !errors.has('phone')">*Invalid phone number -
                    Please enter a valid one</span>

                  <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first("phone") }}</span>
                </div>
              </div>
              
              <template v-if="checkProperty(selected_roleID, 'id') == 6"  >
                <immiPhone :fieldsArray="[]" :display="true" :tplkey="''" @updatephoneCountryCode="updatehomePhoneCode" :countrycode="new_user.homePhoneCountryCode.countryCode" cid="benhomePhoneNumber" formscope="" v-model="new_user.homePhone" :tplsection="'beneficiaryInfo'"  :fieldName="'new_user_homePhoneNumber'" label="Mobile Telephone Number" placeHolder="Mobile Telephone Number" />
                <immiPhone :fieldsArray="[]" :display="true" :tplkey="''" @updatephoneCountryCode="updateFaxPhoneCode" :countrycode="new_user.faxCountryCode.countryCode" cid="benhomePhoneNumber" formscope="" v-model="new_user.fax" :tplsection="'Fax'"  :fieldName="'new_user_fax'" label="Fax Number" placeHolder="Fax Number" />
              </template>
              
              
              

            </div>
            <!----
            allUsstates:[],
      licensingAuthorityStates:[],
      barNumber
      
    
     {{licensingAuthorityStates}} --{{barNumber}} {
          stateDetails:null,
          barNumber:''
        }   -->
            <template v-if="(checkProperty(selected_roleID, 'id') == 6)">

              <template v-for="(state, index) in licensingAuthorityStates">
                <div :key="index" class="vx-row delete-row">

                  <div class="vx-col w-1/2">
                    <div class="form_group">
                      <div class="con-select w-full">
                        <label for class="vs-select--label">Licensing Authority<em>*</em></label>

                        <multiselect v-model="state.stateDetails" :options="allUsstates" :multiple="false"
                          :hideSelected="true" :close-on-select="true" :clear-on-select="true" :preserve-search="true"
                          :select-label="''" placeholder="Select Authority States " label="name" track-by="_id"
                          :preselect-first="false" v-validate="'required'" :name="'licensingAuthorityStates_' + index"
                          data-vv-as="Licensing Authority State" @input="filterStates">
                          <template slot="selection" slot-scope="{ values, isOpen }">
                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                              State(s) selected</span>
                            <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                          </template>
                        </multiselect>
                      </div>
                      <span class="text-danger text-sm" v-show="errors.has('licensingAuthorityStates_' + index)">{{
                        errors.first('licensingAuthorityStates_' + index) }}</span>
                    </div>
                  </div>
                  <div class="vx-col w-1/2 add_licensing">
                    <div class="form_group">
                      <label class="form_label">Bar Number<em>*</em></label>
                      <vs-input  v-model="state.barNumber" :name="'barNumber' + index" v-validate="'required|max:15'"
                        class="w-full" data-vv-as="Bar Number"
                        oninput="this.value = this.value.replace(/[^a-z A-Z 0-9  ]/g, '');" />
                      <span class="text-danger text-sm" v-show="errors.has('barNumber' + index)">{{
                        errors.first("barNumber" + index) }}</span>
                    </div>
                    <div class="delete" v-if="licensingAuthorityStates.length > 1">
                      <a @click="removeAttornyState(index)"> <img src="@/assets/images/main/delete-row-img.svg" /></a>
                    </div>
                  </div>
                </div>
              </template>
              <div class="vx-row">

                <div class="vx-col w-1/3 " style="margin-bottom:15px">
                  <a class="add-more d-inline-flex m-0" @click="addAttornyState(index)"><span class="mr-2">+</span>Add
                    More</a>
                </div>
              </div>
              <!-- <div class="vx-col w-full" v-if="isptnrAttorneySignByInternal">
                    <div class="form_group">
                      <div class="con-select w-full">
                        <label for class="vs-select--label">Electronic Signature</label>
                        <div class="uploadsec_wrap">
                                <div class="w-full">
                                    <div  @click="uploadMainDocuments=[]">
                                        <file-upload v-model="uploadMainDocuments"
                                        :accept="'.jpg,.jpeg,.png'"
                                                class="file-upload-input mb-0" style="height:50px; padding:0px;" :name="'documents'" :multiple="true" :hideSelected="true"   data-vv-as="Electronic Signature"  @input="uploadToS3MainDocuments(0,uploadMainDocuments,'signDocument')">
                                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                                    Upload
                                        </file-upload>
                                        <span class="file-type mb-0">(File Type: JPEG,PNG,JPG. Max file size: 200MB)</span>
                                         <span class="text-danger text-sm" v-show="errors.has('documents')">{{ errors.first('documents'+index) }}</span>
                                            </div>
                                            <VuePerfectScrollbar class="scrollbardoc">
                                                <div class="uploded-files_wrap mt-3" >
                                                    <div class="w-full" v-for="(fil, fileindex) in uploadOriginalDocument" :key="fileindex">
                                                    
                                                        <div class="uploded-files">
                                                            <vx-input-group class="form-input-group">
                                                                <vs-input v-on:keyup="filameChenged(fileindex)"  v-validate="'required'" class="w-full" :name="'fName'+fileindex" v-model="fil['name']" data-vv-as="File Name" />
                                                                <span class="text-danger text-sm" v-show="errors.has('fName'+fileindex)">{{ errors.first('fName'+fileindex) }}</span>

                                                                <div class="delete" style="z-index:999" @click="remove(fil, uploadOriginalDocument ,fileindex)">
                                                                    <img src="@/assets/images/main/cross.svg" />
                                                                </div>
                                                            </vx-input-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </VuePerfectScrollbar>
                                        </div>     
                            </div>
                       
                      </div>
                     
                    </div>
              </div> -->
           <!-- <div class="vx-row" v-if="isptnrAttorneySignByInternal">
              
              
                <!-- <div class="vx-row" v-if="isptnrAttorneySignByInternal">
                <div class="form-container">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                          
                            <div class="uploadsec_wrap ff">
                                <div class="w-full">
                                    <div  @click="uploadMainDocuments=[]">
                                        <file-upload v-model="uploadMainDocuments"
                                                :accept="'application/pdf , application/msword'" 
                                                class="file-upload-input mb-0" style="height:50px; padding:0px;" :name="'documents'" :multiple="true" :hideSelected="true" v-validate="'required'" label="Upload Signature" data-vv-as="Upload Signature"  @input="uploadToS3MainDocuments(0,uploadMainDocuments)">
                                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                                    Upload
                                        </file-upload>
                                        <span class="file-type mb-0">(File Type: PDF, DOC. Max file size: 200MB)</span>
                                               
                                            </div>
                                            <VuePerfectScrollbar class="scrollbardoc">
                                                <div class="uploded-files_wrap mt-3" >
                                                    <div class="w-full" v-for="(fil, fileindex) in uploadOriginalDocument" :key="fileindex">
                                                    
                                                        <div class="uploded-files">
                                                            <vx-input-group class="form-input-group">
                                                                <vs-input v-on:keyup="filameChenged(fileindex)"  v-validate="'required'" class="w-full" :name="'fName'+fileindex" v-model="fil['name']" data-vv-as="File Name" />
                                                                <span class="text-danger text-sm" v-show="errors.has('fName'+fileindex)">{{ errors.first('fName'+fileindex) }}</span>

                                                                <div class="delete" style="z-index:999" @click="remove(fil, uploadOriginalDocument ,fileindex)">
                                                                    <img src="@/assets/images/main/cross.svg" />
                                                                </div>
                                                            </vx-input-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </VuePerfectScrollbar>
                                        </div>     
                            </div>
                                
                            </div>
                        </div>
                    </div>
         </div>
        && isptnrAttorneySignByInternal
        -->
              
            </template>
            <template v-if="(checkProperty(selected_roleID, 'id') == 6 || checkProperty(selected_roleID, 'id') == 12) ">
              <div class="vx-col w-full" >
                    <div class="form_group">
                      <div class="con-select w-full">
                        <label for class="vs-select--label">Electronic Signature</label>
                      <template v-if="true" >
                        <div class="uploadsec_wrap uploadsec_wrap_v2">
                            <customCropImage @input="updateCropData" :vvas="'Electronic Signature'"  :display="true" :cid="'ElectronicDocuments'"  :formscope="''" :fieldName="'ElectronicDocuments'" :required="true"/>
                            <div class="uploded-files_wrap" >
                            <div class="w-full" v-for="(fil, fileindex) in uploadOriginalDocument" :key="fileindex">

                              <div class="uploded-files">
                                  <vx-input-group class="form-input-group">
                                      <vs-input  v-on:keyup="filameChenged(fileindex)"  v-validate="'required'" class="w-full" :name="'fName'+fileindex" v-model="fil['name']" data-vv-as="File Name" />
                                      <span class="text-danger text-sm" v-show="errors.has('fName'+fileindex)">{{ errors.first('fName'+fileindex) }}</span>
                                      <div class="delete">
                                        <img style="width:13px" src="@/assets/images/main/down-arrow2.svg" @click="downloads3file(fil)" />
                                      </div>
                                      <div class="delete" style="z-index:999" @click="remove(fil, uploadOriginalDocument ,fileindex)">
                                          <img src="@/assets/images/main/cross.svg" />
                                      </div>
                                  </vx-input-group>
                              </div>
                            </div>
                            </div>
                          </div>
                        </template>
                      <template v-else>
                          <div class="uploadsec_wrap ff"   >
                              <div class="w-full">
                                  <div  @click="uploadMainDocuments=[]" >
                                      <file-upload v-model="uploadMainDocuments"
                                      :accept="imageDocEntity"
                                              class="file-upload-input mb-0" style="height:50px; padding:0px;" :name="'documents'" :multiple="false" :hideSelected="true"   data-vv-as="Electronic Signature"  @input="uploadToS3MainDocuments(0,uploadMainDocuments,'signDocument')">
                                                  <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                                  Upload
                                      </file-upload>
                                      <span class="loader" v-if="elsUploading"><img src="@/assets/images/main/loader.gif" /></span>
                  
                                      <span class="file-type mb-0">(File Type: JPEG,PNG,JPG. Max file size: 200MB)</span>
                                        <span class="text-danger text-sm" v-show="errors.has('documents')">{{ errors.first('documents'+index) }}</span>
                                          </div>
                                          
                                          <div class="uploded-files_wrap" >
                                                  <div class="w-full" v-for="(fil, fileindex) in uploadOriginalDocument" :key="fileindex">
                                                  
                                                      <div class="uploded-files">
                                                          <vx-input-group class="form-input-group">
                                                              <vs-input v-on:keyup="filameChenged(fileindex)"  v-validate="'required'" class="w-full" :name="'fName'+fileindex" v-model="fil['name']" data-vv-as="File Name" />
                                                              <span class="text-danger text-sm" v-show="errors.has('fName'+fileindex)">{{ errors.first('fName'+fileindex) }}</span>

                                                              <div class="delete" style="z-index:999" @click="remove(fil, uploadOriginalDocument ,fileindex)">
                                                                  <img src="@/assets/images/main/cross.svg" />
                                                              </div>
                                                          </vx-input-group>
                                                      </div>
                                                  </div>
                                              </div>
                                      </div>     
                          </div>
                      </template>
                            
                       
                      </div>
                     
                    </div>
              </div>
            </template>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="form_group" v-if="[3].indexOf(getUserRoleId) > -1 && !isUserEdit">
                  <template>
                    <div class="address-suite">
                      <ul class="demo-alignment custom-radio" vs-type="flex" vs-align="center">
                        <li>
                          <span class="small-header pad0" style="margin-top:0px;float:left;margin-right:10px;">Address:</span>

                          <span style="margin-top:0px;"><vs-checkbox name="useCompanyAdress" v-model="useCompanyAdress"
                              @change="useCampanyAdress">Use company default address</vs-checkbox></span>
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <div style="min-height:200px;">
              <!-------v-if="reloadAddress"-->
              <template>
                <template v-if="(checkProperty(selected_roleID, 'id') == 6)">
                  <addressFields :disableCountry="countryDisable" :showaptType="true" :addFormContainerCls='false'
                    :validationRequired="false" :countries="countries" :address="new_user.address"
                    :cid="'mailingaddress'" />
                </template>
                <template v-else>
                  <addressFields :showaptType="true" :addFormContainerCls='false' :validationRequired="false"
                    :countries="countries" :address="new_user.address" :cid="'mailingaddress'" />
                </template>
              </template>

            </div>

            <div class="vx-row" v-if="(checkProperty(selected_roleID, 'id') == 6)">
              <div class="vx-col w-full">

                <div class="form_group new_vs_switch_form_group">
                  <!-- <label class="form_label">While generating forms do you want to use this address? </label>
                  <div class="table_switch">

                    <vs-switch v-model="new_user.useOfficeAddress">
                      <span slot="on">Yes</span>
                      <span slot="off">No</span>
                    </vs-switch> -->
                    <redioButtonsBoolean  :required="true"  :defaultError="true"
                        :wrapclass="'md:w-full'" :cid="'useOfficeAddress'"  :fieldName="'useOfficeAddress'"  
                        v-model="new_user.useOfficeAddress"  label="While generating forms do you want to use this address?" placeHolder="" />
                  <!-- </div> -->



                </div>
              </div>
              
            </div>
            <div class="vx-row" v-if="checkProperty(selected_roleID, 'id') == 6">
                <div class="vx-col w-full" >
                  <vs-checkbox id="altCheck" class="mx-0"  @click="clearCheck(altCheck)" name="altCheck" v-model="altCheck">Use alternate email ID for forms
                  </vs-checkbox>
                  <div class="form_group" v-if="altCheck">
                    <label class="form_label">Alternate Email</label>
                      <vs-input :key="'AlternateEmail'" class="w-full" name="Alternate Email" v-validate="'email'"
                        v-model="altEmailForForms" data-vv-as="Alternate Email" v-on:keyup="sameEmail()"/>
                    <span class="text-danger text-sm" v-show="errors.has('Alternate Email')">{{ errors.first("Alternate Email") }}</span>
                    <span class="text-danger text-sm" v-if="errorMsg">{{ errorMsg }}</span>
                </div>
              </div>
             </div>

            <div class="vx-row"
              v-if="[1, 2].indexOf(getUserRoleId) <= -1 && [1, 2, 3].indexOf(checkProperty(selected_roleID, 'id')) <= -1">
              <div class="divider"></div>
              <div class="vx-col w-full">
                <div class="form_group d-block case-sub-types mb-0">
                  <h3 class="small-header pt-0" style="font-size: 14px;">Access Permissions</h3>
                  <label class="form_label">Case Types</label>
                  <div class="con-select w-full" style="margin-bottom:0 !important">
                    <multiselect :name="'subTypeDetails'" v-model="new_user.subTypeDetails" :options="petitionConfigList"
                      :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select " :preselect-first="false" data-vv-as=" Default Cases" group-values="subTypes"
                      group-label="caseType" :group-select="true" track-by="name" label="name">
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Case
                          Sub Type(s) Selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                      </template>
                    </multiselect>

                    <vs-checkbox v-model="new_user.manageCapRegistration" :fieldName="'manageCapRegistration'"
                      style="margin-top: 12px !important;">Cap Registrations </vs-checkbox>

                  </div>
                  <!-- <span   class="error_msg" v-show="errors.has('subTypeDetails_'+index)"  >{{ errors.first("subTypeDetails_"+index) }}</span> -->

                </div>
              </div>
            </div>

            <div v-show="formerrors.msg">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
            </div>
          </div>

          <div class="popup-footer relative">
            <figure v-if="userCreating" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
            <vs-button color="dark" :disabled="userCreating" @click="inviteUserPopupshow(false)" class="cancel"
              type="filled">Cancel</vs-button>
            <vs-button color="success" :disabled="userCreating || disableSubmitBtn" @click="saveuser(false)" class="save" type="filled">
              <template v-if="isUserEdit">Update </template>
              <template v-else>Submit </template>

            </vs-button>
          </div>
        </form>

      </div>
    </modal>

    <vs-popup class="holamundo main-popup  confirm_modal" title="Replace Branch Manager"
      :active.sync="replaceBranchManagerConformpopUp">
      <div class="form-container">

        <div class="vx-row">
          <div class="vx-col w-full">
            <p>{{ conformMsg }}</p>

          </div>

        </div>

        <div v-show="formerrors.msg">
          <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
            icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
        </div>

      </div>
      <div class="popup-footer relative">
        <figure v-if="userCreating" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
        <vs-button color="dark" :disabled="userCreating"
          @click="replaceBranchManagerConformpopUp = false ; conformMsg = ''" class="cancel" type="filled">No</vs-button>
        <vs-button color="success" :disabled="userCreating" @click="saveuser(true)" class="save" type="filled">
          Yes</vs-button>
      </div>
    </vs-popup>



    <modal name="userDetailsPopupModal" classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
      :reset="true" width="750px" height="auto">
      <div class="v-modal profile_details_modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">User Details</h2>
          <span @click="$modal.hide('userDetailsPopupModal');">
            <em class="material-icons">close</em>
          </span>
        </div>
        <div class="form-container" v-if="!lodedDetails">
          <div class="vx-row">
           
            <div class="vx-col w-1/2">
              <div class="form_group">
                <figure class="dp_img">
                  <img class="user-image" :src="checkProperty(selectedUser, 'profilePicture')"
                    @error="setDefaultPhoto($event, '', type = 'user')" />
                  <figcaption>{{ checkProperty(selectedUser, 'firstName') }}{{ checkProperty(selectedUser
                    , 'middleName') }}{{ checkProperty(selectedUser, 'lastName') }}
                    <span>{{ checkProperty(selectedUser, 'roleDetails', 'name') }}</span>
                  </figcaption>
                </figure>

              </div>
            </div>
          </div>
          <div class="vx-row">
            <!-- <div class="vx-col w-1/2" v-if="checkProperty(selectedUser ,'firstName')">
                  <div class="form_group">
                    <label class="form_label">First Name</label>
                    <span>{{checkProperty(selectedUser ,'firstName')}}</span>
                  </div>
                </div> -->
            <!-- <div class="vx-col w-1/2" v-if="checkProperty(selectedUser ,'middleName')">
                  <div class="form_group">
                    <label class="form_label">Middle Name</label>
                    <span>{{checkProperty(selectedUser ,'middleName')}}</span>
                  </div>
                </div> -->
            <!-- <div class="vx-col w-1/2" v-if="checkProperty(selectedUser ,'lastName')">
                  <div class="form_group">
                    <label class="form_label">Last Name</label>
                    <span>{{checkProperty(selectedUser ,'lastName')}}</span>
                  </div>
                </div> -->

            <div class="vx-col w-1/2" v-if="checkProperty(selectedUser, 'email')">
              <div class="form_group">
                <label class="form_label">Email</label>
                
                <span>{{ checkProperty(selectedUser, 'email') }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2" v-if="checkProperty(selectedUser, 'phone')">
              <div class="form_group">
                <label class="form_label">Phone</label>
                <span>{{ checkProperty(selectedUser, 'phoneCountryCode', 'countryCallingCode') }}
                  {{ checkProperty(selectedUser, 'phone') }}</span>
              </div>
            </div>

            <!-- <div class="vx-col w-1/2" v-if="checkProperty(selectedUser ,'roleDetails','name')">
                  <div class="form_group">
                    <label class="form_label">Role</label>
                    <span>{{checkProperty(selectedUser ,'roleDetails' ,'name')}}</span>
                  </div>
                </div> -->
            <div class="vx-col w-1/2" v-if="checkProperty(selectedUser, 'statusDetails', 'name')">
              <div class="form_group">
                <label class="form_label">Status</label>
                <span>{{ checkProperty(selectedUser, 'statusDetails', 'name') }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2" v-if="checkProperty(selectedUser, 'branches')">
              <div class="form_group">
                <label class="form_label">Branch(s)</label>
                <span>{{ checkProperty(selectedUser, 'branches') }}</span>
              </div>
            </div>

          </div>

          <div class="vx-col w-1/2" v-if="checkProperty(userDetails,'details', 'altEmailForForms')">
              <div class="form_group">
                <label class="form_label">Alternate Email</label>
                <span>{{ checkProperty(userDetails,'details', 'altEmailForForms') }}</span>
              </div>
            </div>
          
          <div class="vx-row" v-if="userDetails['signDocs']">
            <div class="vx-col w-full">
              <h3 class="small-header pt-0 pb-6">Licensing Authority States</h3>
              <template>
              <div class="vx-col lg:w-1/2 md:w-1/2 w-full" v-for="( lstate, ind) in templicensingAuthorityStates"
                :key="ind">
                <div class="main-list Licensing_blocks">
                  <p>
                    <a>State</a><span>{{ checkProperty(lstate, "stateDetails", "name") }}</span>
                  </p>
                  <p>
                    <a>Bar Number</a><span>{{ checkProperty(lstate, "barNumber") }}</span>
                  </p>
                </div>
              </div>
            </template>
            </div>
          </div>
          
          
          <div class="vx-row">
            <div class="vx-col w-1/2">
                <div class="lca_header_list" v-if="userDetails['signDocs'] && userDetails['signDocs'].length>0">
                    <div class="list__cnt">
                        <div class="list-elements">
                            <h3 class="small-header pt-1 pb-2" v-if="checkProperty(userDetails ,'signDocs')" style="font-size: 14px;">Electronic Signature</h3>
                            <!-- <h4 v-if="checkProperty(selectedUser ,'signDocs')">Electronic Signature</h4> -->
                          <ul>
                            <template v-if="userDetails['signDocs'] && userDetails['signDocs'].length>0">
                                <template v-for="(signDoc ,index) in userDetails['signDocs']">                       
                                    <li :key="index" v-if="checkProperty(signDoc,'status')" :title="checkProperty(signDoc,'name')" @click="download_or_view(signDoc)">        
                                        <figure>               
                                            <img v-if="checkFileFormat(signDoc['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                            <img v-else src="@/assets/images/main/icon-img.svg" /> 
                                            <span class="download_icon"></span>
                                        </figure> 
                                    </li>
                                </template>  
                            </template>
                          </ul>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="form-container" v-else>
          <div class="vx-row">
          
            <div class="vx-col w-1/2">
              <div class="form_group">
                <figure class="dp_img">
                  <img class="user-image" :src="checkProperty(userDetails, 'details', 'profilePicture')"
                    @error="setDefaultPhoto($event, '', type = 'user')" />
                  <figcaption>{{ checkProperty(userDetails, 'firstName') }}{{ checkProperty(userDetails
                    , 'middleName') }}{{ checkProperty(userDetails, 'lastName') }}
                    <span>{{ checkProperty(userDetails, 'roleDetails', 'name') }}</span>
                  </figcaption>
                </figure>

              </div>
            </div>
          </div>
          <div class="vx-row">
            
            <div class="vx-col w-1/2" v-if="checkProperty(userDetails, 'email')">
              <div class="form_group">
                <label class="form_label">Email</label>
               
                <span>{{ checkProperty(userDetails, 'email') }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2" v-if="checkProperty(userDetails, 'phone')">
              <div class="form_group">
                <label class="form_label">Phone</label>
                <span>{{ checkProperty(userDetails, 'phoneCountryCode', 'countryCallingCode') }} {{
                  checkProperty(userDetails
                    , 'phone') }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2" v-if="checkProperty(userDetails,'details', 'homePhone')">
              <div class="form_group">
                <label class="form_label">Mobile Telephone Number</label>
                <span>{{ checkProperty(userDetails['details'], 'homePhoneCountryCode', 'countryCallingCode') }} {{
                  checkProperty(userDetails['details']
                    , 'homePhone') }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2" v-if="checkProperty(userDetails['details'], 'fax')">
              <div class="form_group">
                <label class="form_label">Fax</label>
                <span>{{ checkProperty(userDetails['details'], 'faxCountryCode', 'countryCallingCode') }} {{
                  checkProperty(userDetails['details']
                    , 'fax') }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2" v-if="checkProperty(userDetails, 'statusDetails', 'name')">
              <div class="form_group">
                <label class="form_label">Status</label>
                <span>{{ checkProperty(userDetails, 'statusDetails', 'name') }}</span>
              </div>
            </div>
            <div class="vx-col w-1/2" v-if="checkProperty(userDetails, 'branches')">
              <div class="form_group">
                <label class="form_label">Branch(s)</label>
                <span>{{ checkProperty(userDetails, 'branches') }}</span>
              </div>
            </div>
          </div>
         

          <div class="vx-row" v-if="checkProperty(selectedUser, 'roleId') == 6">
            <div class="vx-col w-1/2">
              <h3 class="small-header pt-1 pb-2" style="font-size: 14px;">Licensing Authority States</h3>
              <div class="Licensing_blocks_list">
                  <div class="main-list Licensing_blocks" v-for="( lstate, ind) in templicensingAuthorityStates"
                    :key="ind">
                    <p>
                      <a>State</a><span>{{ checkProperty(lstate, "stateDetails", "name") }}</span>
                    </p>
                    <p>
                      <a>Bar Number</a><span>{{ checkProperty(lstate, "barNumber") }}</span>
                    </p>
                  </div>
                </div>
            </div>
            <div class="vx-col w-1/2" v-if="checkProperty(userDetails,'details', 'altEmailForForms')">
              <div class="form_group">
                <label class="form_label">Alternate Email</label>
                <span>{{ checkProperty(userDetails,'details', 'altEmailForForms') }}</span>
              </div>
            </div>
          </div>
          <div class="vx-row" v-if="userDetails['signDocs']">
            <div class="vx-col w-1/2">
                <div class="lca_header_list" v-if="userDetails['signDocs'] && userDetails['signDocs'].length>0">
                    <div class="list__cnt">
                        <div class="list-elements">
                            <!-- <h4 v-if="checkProperty(selectedUser ,'signDocs')">Electronic Signature</h4> -->
                            <h3 class="small-header pt-1 pb-2" v-if="checkProperty(userDetails ,'signDocs')" style="font-size: 14px;">Electronic Signature</h3>
                          <ul>
                            <template v-if="userDetails['signDocs'] && userDetails['signDocs'].length>0">
                                <template v-for="(signDoc ,index) in userDetails['signDocs']">                       
                                    <li :key="index" v-if="checkProperty(signDoc,'status')" :title="checkProperty(signDoc,'name')" @click="download_or_view(signDoc)">        
                                        <figure>               
                                            <img v-if="checkFileFormat(signDoc['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                            <img v-else-if="checkFileFormat(signDoc['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                            <img v-else src="@/assets/images/main/icon-img.svg" /> 
                                            <span class="download_icon"></span>
                                        </figure> 
                                    </li>
                                </template>  
                            </template>
                          </ul>
                      </div>
                    </div>
                </div>
            </div>
          </div>
          <template
            v-if="((checkProperty(userDetails, 'defaultCaseAssignConfig') && checkProperty(userDetails, 'defaultCaseAssignConfig', 'subTypeDetails')
              && checkProperty(userDetails['defaultCaseAssignConfig'], 'subTypeDetails', 'length') > 0) || checkProperty(userDetails, 'manageCapRegistration') == true)">
            <div class="divider" style="margin: 0 0 20px;"></div>
            <div class="vx-col w-full">
              <h3 class="small-header pt-0" style="font-size: 14px;">Access Permissions</h3>
              <div class="vx-row p-4">
                <ul class="uploaded-list note_uploads note_uploads-v2">
                  <template v-if="checkProperty(userDetails, 'defaultCaseAssignConfig') && checkProperty(userDetails, 'defaultCaseAssignConfig', 'subTypeDetails')
                    && checkProperty(userDetails['defaultCaseAssignConfig'], 'subTypeDetails', 'length') > 0">
                    <template v-for="(item, index) in userDetails['defaultCaseAssignConfig']['subTypeDetails']">
                      <vs-chip>
                        {{ item.name }}
                      </vs-chip>
                    </template>
                  </template>
                  <template v-if="checkProperty(userDetails, 'manageCapRegistration') == true">
                    <vs-chip>
                      {{ "Cap Registrations" }}
                    </vs-chip>
                  </template>
                </ul>
              </div>
            </div>

          </template>
          <label class="form_label" v-if="checkProperty(userDetails['roleChangeLogs'], 'length') > 0">
            <h3 class="small-header pt-0 pb-3">Role Change History</h3>
          </label>
          <div class="vx-row" v-if="checkProperty(userDetails['roleChangeLogs'], 'length') > 0">
            <div class="role-history" v-for="(role, indexx) in userDetails['roleChangeLogs']" :key="indexx">
              <p class="role"> <span v-if="checkProperty(role, 'roleName') && checkProperty(role, 'oldRoleName')">Role
                  Changed From </span><span>{{ checkProperty(role, 'oldRoleName') }}</span> To <span>{{ checkProperty(role
                    , 'roleName') }}</span>
                <span v-if="checkProperty(role, 'updatedByName') && checkProperty(role, 'updatedOn')"></span>By
                <span>{{ checkProperty(role, 'updatedByName') }}<em v-if="checkProperty(role, 'updatedByRoleName')">({{
                  checkProperty(role
                    , 'updatedByRoleName') }})</em></span> On <span>{{ role.updatedOn | formatDateTime }}</span>

              </p>
              <!-- <p class="date"> </p> -->
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="assignPetitionerPopupModal" classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
      :reset="true" width="450px" height="auto">
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">
            Assign Petitioner
          </h2>
          <span @click="$modal.hide('assignPetitionerPopupModal');">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form data-vv-scope="permDeletForm">
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="form_group">
                  <label class="typo__label">Select Petitioner<em>*</em></label>
                  <multiselect v-model="selectedPetitionerDetails" :options="petitionersList" :multiple="false"
                    :hideSelected="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                    :select-label="'Select Petitioner'" placeholder="Select Petitioner" label="name" track-by="name"
                    :preselect-first="false" :searchable="true" name="selectPetitioner" data-vv-as="Petitioner"
                    v-validate="'required'">
                  </multiselect>
                </div>
                <span class="text-danger text-sm" v-show="errors.has('permDeletForm.selectPetitioner')">{{
                  errors.first("permDeletForm.selectPetitioner") }}</span>
              </div>
            </div>
            <div v-show="formerrors.msg">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
            </div>
          </div>
        </form>
        <div class="popup-footer relative">
          <figure v-if="assigning" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
          <vs-button color="dark" class="cancel" type="filled" @click="$modal.hide('assignPetitionerPopupModal');">Cancel
          </vs-button>
          <vs-button :disabled="assigning" color="success" class="save" type="filled"
            @click="submitPetitionAssign()">Submit
          </vs-button>
        </div>

      </div>
    </modal>
    <RevertAction v-if="showRevertPopup" @handleCloseRevertPopup="handleCloseRevertPopup" :userData="userData"/>
    <vs-popup class="holamundo main-popup" :title="'User Already Exists'" :active.sync="userConform">
      <!-- (checkProperty(selectedUser,'statusId') ==2?'Inactivate ':' Activate')+' User' -->
      <div class="form-container">

        <div class="vx-row">
          <div class="vx-col w-full">
            <p>{{ userConformMsg }}</p>
          </div>

        </div>

        <div v-show="userConformErrorMsg">
          <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
            icon="IP-information-button" active="true">{{ userConformErrorMsg }}</vs-alert>
        </div>

      </div>
      <div class="popup-footer relative">
        
        <figure  class="loader" v-if="loading"> <img src="@/assets/images/main/loader.gif" />  </figure>
        <vs-button color="dark" class="cancel" type="filled" @click="userConform = false">Cancel </vs-button>
      <vs-button  color="success" class="save" :disabled="loading" type="filled"
          v-on:click.stop.prevent="userConformActivate()">
          Activate
        </vs-button>
        
      </div>
    </vs-popup>
    <mfaDisableOrEnable v-if="showMFAPopup" @hideMfa="hideMfa" :userDetails="selectedItem" />
  </div>
</template>

<script>
import mfaDisableOrEnable from "@/views/actionpopups/mfaDisableOrEnable.vue";
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import customCropImage from './forms/fields/customCropImage.vue'
import immiPhone from "@/views/forms/fields/phonenumber.vue";
import * as _ from "lodash";
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker-inv";
import Paginate from "vuejs-paginate";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from 'moment'
import PhoneMaskInput from "vue-phone-mask-input";
//import JQuery from 'jquery'
import { TheMask } from 'vue-the-mask'
import { MoreVerticalIcon } from 'vue-feather-icons'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import NoDataFound from "@/views/common/noData.vue";
import addressFields from "@/views/common/addressForm.vue";
import FileUpload from "vue-upload-component/src";
import redioButtonsBoolean from "@/views/forms/fields/redioButtonsBoolean.vue";
import RevertAction from "./common/revertAccountPopup.vue";
export default {
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  components: {
    mfaDisableOrEnable,
    vsInvDropdown,
    redioButtonsBoolean,
    customCropImage,
    immiPhone,
    VuePerfectScrollbar,
    FileUpload,
    addressFields,
    NoDataFound,
    Datepicker,
    Paginate,
    DateRangePicker,
    FormWizard,
    TabContent,
    PhoneMaskInput,
    TheMask,
    VuePhoneNumberInput,
    MoreVerticalIcon,
    RevertAction
  },
  computed: {

    checkUserRoleDisable() {
      if (this.isUserEdit) {
        if ([3, 4].indexOf(this.getUserRoleId) > -1) {

          let userId = this.checkProperty(this.getUserData, "userId");
          if (userId != '' && userId == this.checkProperty(this.selectedUser, '_id') && this.checkProperty(this.selectedUser, '_id') != '' && this.selectedUser) {
            return true
          } else {
            return false
          }

        } else {
          return true
        }



        //alert(this.getUserRoleId);


        //  {{selectedUser['roleId'] isUserEdit}}  
      } else {
        return false;
      }

    },
    //(this.getUserRoleId ==3 && this.selectedBranch && _.has(this.selectedBranch , "_id"))

    validateForm() {
      if (
        (!this.new_user.firstname || this.new_user.firstname.trim() == '')
        || (!this.new_user.lastname || this.new_user.lastname.trim() == '')
        || (!this.new_user.email || this.new_user.email.trim() == '')
        || (!this.new_user.phone || this.new_user.phone == '' || this.new_user.phone == null)

        // (this.getUserRoleId ==3 && this.selectedBranch && _.has(this.selectedBranch , "_id"))

      ) {
        return true;
      } else {
        if (this.getUserRoleId == 3) {
          if (!this.selectedBranch || !_.has(this.selectedBranch, "_id") || this.selectedBranch == null) {
            return true;
          } else {
            return false;
          }

        } else {
          return false;
        }


      }
    }

  },
  data: () => ({
    showMfaAction:false,
    showMFAPopup:false,
    settings: {
      swipeEasing: true,
    },
    userData:null,showRevertPopup:false,
    altCheck : false,
    errorMsg:'',
    altEmailForForms:"",
    hideInactive:false,
    uploadOriginalDocument:[],
    uploadMainDocuments:[],
    elsUploading:false,
    debounce:null,
    userConform:false,
    userConformMsg:'',
    userConformErrorMsg:'',
    conformUserId:'',
    loading: false,
    selectedStatus: null,
    selectedActionItem: null,
    petitionConfigList: [],
    petitionConfigListTemp: [],
    assigning: false,
    petitionersList: [],
    selectedPetitionerDetails: null,
    replaceBranchManagerConformpopUp: false,
    conformMsg: '',
    userDetails: [],
    countryDisable: false,
    reloadAddress: true,
    useCompanyAdress: false,
    countries: [],
    countryCode: "US",
    templicensingAuthorityStates: [],
    updatingPassword: false,
    SetPassword: false,
    setPasswordErrorMsg: '',
    newPassword: '',
    confPassword: '',
    allUsstates: [],
    allUsstatesTemp: [],
    licensingAuthorityStates: [

      {
        stateDetails: null,
        barNumber: ''
      }
    ],
    barNumber: '',
    signDocs: [],
    filterBranch: [],
    userCreating: false,
    isPhoneValid: true,
    contentLoaded: false,
    sortKeys: {},
    sortKey: {},
    approveConformpopUp: false,
    callFromSerch: false,
    selectedItem: null,
    selectedBranch: [],
    branchList: [],
    branchTempList: [],
    selected_createdDateRange: ["", ""],
    autoApply: "",
    formerrors: {
      msg: ""
    },

    date: null,
    visatype: {
      id: 1,
      name: "H1B"
    },
    visasubtype: null,

    selectedUser: null,
    selectedUsername: null,
    lodedDetails: false,
    FillingFreeDetails: false,
    selected_roleID: '',
    new_user: {
      name: "",
      firstname: "",
      lastname: "",
      email: "",
      active: true,
      phoneCountryCode: "+91",
      phone: '',
      "homePhone": "",
      "homePhoneCountryCode": { countryCode: '', countryCallingCode: '' },
      "fax": "",
      "faxCountryCode": { countryCode: '', countryCallingCode: '' },
      address: {
        line1: "", line2: "", countryId: 231, countryDetails: { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" }
        , stateId: '', stateDetails: null, locationId: '', locationDetails: null, zipcode: '', aptType: ''
      },
      signDocs:[],
      usasDefaultAddress: false,
      manageCapRegistration: false,
      
    },
    vuePhone: {
      props: {
        translations: {
          phoneNumberLabel: "Phone Number"
        }
      }
    },
    users: [],
    configDetails: null,
    isptnrAttorneySignByInternal:false,
    version_documentUploaded: [],
    addNewUser: false,
    NewPetition: false,
    visatypes: [],
    visasubtypes: [],
    searchtxt: "",
    query: [],
    country_code: 231,
    all_statusids: [],
    selected_statusids: [],
    final_selected_statusids: [],
    filter_roleIds: [],
    final_filter_roleIds: [],

    all_states: [],
    seleted_states: [],
    final_selected_states: [],
    locations: [],
    // locationIds
    all_locations: [],
    seleted_locations: [],
    final_selected_locations: [],

    date_range: [],
    page: 1,
      perPeges: [10,25,50,75,100],
      perpage: 25,
      totalCount:0,
      totalpages: 0,
    all_userroles: [],

    selected_userrole: '',
    switch2: true,
    users_status: {},
    isUserEdit: true,
    tenantDetails: [],
    popUpText: '',
    popUpTitle: '',
    disable_uploadBtn: false,
    disableSubmitBtn:false,
  }),
  watch: {
    searchtxt: function (value) {

      let self =this;
      this.page =1;
    clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        self.getUsersList(true);
      }, 900)
     /// this.getUsersList(true);
    },
    // new_user: function (value) {

    //   let temp_address = _.cloneDeep(value['address'])
    //   if(temp_address.line1 == this.checkProperty(this.tenantDetails,'address','line1') && 
    //   temp_address.line2 == this.checkProperty(this.tenantDetails,'address','line2') && 
    //   temp_address.countryId == this.checkProperty(this.tenantDetails,'address','countryId') && 
    //   temp_address.countryDetails == this.checkProperty(this.tenantDetails,'address','countryDetails') && 
    //   temp_address.stateId == this.checkProperty(this.tenantDetails,'address','stateId') && 
    //   temp_address.stateDetails == this.checkProperty(this.tenantDetails,'address','stateDetails') &&
    //   temp_address.locationId == this.checkProperty(this.tenantDetails,'address','locationId') &&
    //   temp_address.locationDetails == this.checkProperty(this.tenantDetails,'address','locationDetails') && 
    //   temp_address.zipcode == this.checkProperty(this.tenantDetails,'address','zipcode')){
    //    this.useCompanyAdress = true
    //   }
    //   else{
    //     this.useCompanyAdress = false
    //   }
    // },

  }, 
  methods: { 
    hideMfa(reload = false){
      this.showMFAPopup = false;
      if(reload){
        this.getUsersList();
      }
    },
    psSectionScroll() { },
    showRevertAction(tr){
        this.userData=tr
        this.showRevertPopup=true
      },
      handleCloseRevertPopup(success = false){
        this.showRevertPopup=false
        if(success){
          setTimeout(()=>{
            this.getUsersList(true); 
          },10)
          
        }

      },
    sameEmail(){
      if(this.new_user.email==this.altEmailForForms){
        // this.altEmailForForms = "";
        this.errorMsg = '*Email and Alternate Email can not be same';
        this.disableSubmitBtn = true;
      }else{
        this.errorMsg = '';
        this.disableSubmitBtn = false;
      }
    },
    changeperPage(){
      this.page = 1;
        this.getUsersList(true);
    },
    updateCropData(data){
      
          //this.croppedImageData =data;
          this.uploadOriginalDocument =[];
          this.uploadOriginalDocument.push(data) ;
        },
    updatehomePhoneCode(data){ 
      this.new_user.homePhoneCountryCode =data;
    },
    updateFaxPhoneCode(data){ 
      this.new_user.faxCountryCode =data;
    },
    download_or_view(value) {
            if (_.has(value, "path")) {
                value['url'] = value['path'];
                value['document'] = value['path'];
            }
            if (_.has(value, "url")) {
                value['path'] = value['url'];
                value['document'] = value['url'];
            }
            if (_.has(value, "document")) {
                value['path'] = value['document'];
                value['url'] = value['document'];
            }
        
                this.downloads3file(value);
            

        },
    filameChenged(fileindex) {
      this.disable_uploadBtn = false;
      //uploadOriginalDocument
          if (this.uploadOriginalDocument.length > 0) {
              _.forEach(this.uploadOriginalDocument, (fl, value) => {
                        //let fname = fl.name;
                        let fname = fl.name;
                        fname = fname.trim();
                        if (!fname) {
                            this.disable_uploadBtn = true;
                        }
              });
          }
        },
    uploadToS3MainDocuments(index,docs,type="signDocument"){
            let self = this
             docs = docs.map(
                item =>
                (item = {

                  
                    name: item.name,
                    file: item.file,
                    document: "",
                    path:'',
                    size:item.size ? item.size : null,
                    mimetype: item.type,
                    uploadedBy:item.uploadedBy?item.uploadedBy:this.checkProperty(this.getUserData,'userId')!=''?this.checkProperty(this.getUserData,'userId'):null,
                    uploadedByName:item.uploadedByName?item.uploadedByName:this.checkProperty(this.getUserData,'name')!=''?this.checkProperty(this.getUserData,'name'):'',
                    uploadedByRoleId:item.uploadedByRoleId?item.uploadedByRoleId:this.getUserRoleId?this.getUserRoleId:null,
                    uploadedByRoleName:item.uploadedByRoleName?item.uploadedByRoleName:this.checkProperty(this.getUserData,'loginRoleName'),
                })
            );
            let allFiles = [];
          
      if(type=='signDocument'){
        let imageMymTypes =['image/bmp','image/jpeg','image/x-png','image/png'];
        docs.forEach((doc, index) => {
          if(imageMymTypes.indexOf(doc.mimetype) >-1){
            allFiles.push(doc);
          }
        })
        docs = _.cloneDeep(allFiles);

              
            }
            if (docs.length > 0) {
              if(type=='signDocument'){
                this.elsUploading = true;
              }
                let filIndex = 0;
                docs.forEach(doc => { 
                  this.fuploder = true;
                this.disable_uploadBtn = true;
                    let formData = new FormData();
                    formData.append("files", doc.file);
                    formData.append("secureType", "public");
                     formData.append("getDetails", true);
                    // alert(1)
                    this.$store.dispatch("uploadS3File", formData).then(response => {
                         filIndex++;
                         if (filIndex >= self.uploadMainDocuments.length) {
                            self.fuploder = false;
                            self.disable_uploadBtn = false;
                        }
                        response.data.result.forEach(urlGenerated => {
                            //doc.document = urlGenerated;
                            doc.path = urlGenerated.path;
                            if(self.checkProperty( urlGenerated,'extn')){
                              doc.extn = urlGenerated['extn']
                            }
                            delete doc.file;
                            delete doc.document;

                            //this.uploadMainDocuments.push(doc);
                            if(type=='signDocument'){
                              
                               self.uploadOriginalDocument =[];
                            }
                              self.uploadOriginalDocument.push(doc);
                            self.uploadOriginalDocument = _.cloneDeep(self.uploadOriginalDocument)
                            self.elsUploading = false;
                      
                           
                           // alert(JSON.stringify(self.uploadOriginalDocument));
                        });
                       
                    });
                
                    
                });
            }else{
              if(type=='signDocument'){
                 this.showToster({  message: "Upload only image files",  isError: true,  });
              }
            }

        },
        remove(item, data, filindex) {
      data.splice(filindex, 1);
      this.removeFileFromS3(item)
    },
    getGlobalConfigDetails() {
    let postData = {}
     //this.configDetails =null
      let path = 'global-config/details'
        this.$store.dispatch("commonAction", { data: postData, path: path })
        .then((response) => {
          this.configDetails = response['config'];
          if(this.configDetails.ptnrAttorneySignByInternal==true){
            this.isptnrAttorneySignByInternal=true;
          }
          if(this.configDetails && this.configDetails['mfaRequired']){
            if(this.configDetails['mfaConfig'] && this.configDetails['mfaConfig']['enableTo'] && this.configDetails['mfaConfig']['enableTo']['length']>0){
              let findObj = _.find(this.configDetails['mfaConfig']['enableTo'], {_id:1, name: "Internal Users", enable:true});
              if(findObj){
                this.showMfaAction = true;
              }else{
                this.showMfaAction = false;
              }
            }else{
              this.showMfaAction = false;
            }
          }else{
            this.showMfaAction = false;
          }
        }).catch((err) => {
      })
    },
    userConformActivate(){
      this.userConformErrorMsg = '';
      let postData ={"userId":''};
     
      if([1,2].indexOf(this.getUserRoleId)<=-1){
        postData = {"userId":'',"tenantId":'' };
        postData['tenantId'] = this.checkProperty(this.getUserData, 'tenantId')
      }
      postData['userId'] = this.conformUserId;
      this.loading = true;
      this.$store.dispatch("commonAction", { "data": postData, "path": "users/send-activation-link" })
          .then(response => {
            
              this.userConform =false;
              this.userConformMsg ='';
              this.conformUserId ='';
              this.loading = false;
              this.showToster({ message:response.message, isError: false });
              this.inviteUserPopupshow(false);
          }).catch((error) => {
            this.userConformErrorMsg = error;
              //this.showToster({ message:error, isError: true });
               this.loading = false;
              //this.userConform =false;
              // this.userConformMsg ='';
              // this.conformUserId ='';
              // this.loading = false;
          })
    },
    openactiveConform(item, statusId = 0) {
      this.selectedStatus = statusId
      this.popUpTitle = '';
      if (this.selectedStatus == 2) {
        this.popUpText = 'Are you sure of activate this User?';
        this.popUpTitle = "Active ";
      }
      if (this.selectedStatus == 3) {
        this.popUpText = 'Are you sure inactive this User?';
        this.popUpTitle = "Inactive ";
      }

      if (this.selectedStatus == 4) {
        this.popUpText = 'Are you sure delete this User?';
        this.popUpTitle = " Delete";
      }
      this.loading = false;
      this.formerrors.msg = '';
      this.selectedActionItem = item
      this.approveConformpopUp = true
      this.hideInactive = false
    },

    toggleActivate(statusId = 0) {
      this.formerrors.msg = '';
      let payLoad = {
        "userId": this.selectedActionItem._id,
        "statusId": this.selectedStatus,
        "statusName": '',
      };
      if (this.selectedStatus == 2) {
        payLoad['statusName'] = 'Active'
      }
      if (this.selectedStatus == 3) {
        payLoad['statusName'] = 'Inactive'
      }
      if (this.selectedStatus == 4) {
        payLoad['statusName'] = 'Delete'
      }
      //alert(JSON.stringify(payLoad))
      this.loading = true;

      this.hideInactive = false;
      this.$store.dispatch("changeuserStatus", payLoad).then((res) => {
        this.loading = false;
        this.approveConformpopUp = false;
        this.showToster({ message: res.message, isError: false });
        this.set_filter();
        this.hideInactive = false;
      }).catch((error) => {
        this.loading = false;
        this.formerrors.msg = error.message;
        //this.showToster({message:error,isError:true });
        this.selectedUser = null;
        this.selectedActionItem = null;
        // this.hideInactive = false;
        if(_.has(error,'result','error') && this.checkProperty(error['result'],'error','code') == 'LINKED_WITH_PETITION'){
          this.hideInactive = true;
        }
      });

    },
    getPetitionConfigList() {


      let postData = {
        "filters": {
          "tenantIds": [], // Send only for roles 1 and 2
          "tenantCustomId": "",
          "statusList": [],
          "activeList": [],
          "typeIds": [],
          "subTypeIds": [],
          "statusList": [],
          "createdDateRange": []
        },
        "page": 1, // Optional when 'getAll' send as 'true'
        "perpage": 100000000,// Optional when 'getAll' send as 'true'
        "getAll": true, // Send as 'true' to get all list
        "getByPetitionType": true

      };
      if (this.checkProperty(this.getUserData, 'tenantDetails', "customId")) {
        postData['filters']['tenantCustomId'] = this.checkProperty(this.getUserData, 'tenantDetails', "customId");
      }
      this.petitionConfigList = [];
      this.petitionConfigListTemp = [];

      this.$store
        .dispatch("commonAction", { data: postData, path: "/petition-config/list" })
        .then((response) => {
          let petitionConfigList = response.list;
          this.caseTypesList = [];
          _.forEach(petitionConfigList, (mainTypeItem) => {
            if (this.checkProperty(mainTypeItem, 'isCaseTypeSelected') != false) {
              let groupItem = {
                caseType: '',
                caseTypeId: '',
                "subTypes": [],
                "isSelected": true,
                "isCaseTypeSelected": true,
                code: '',
              }
              groupItem['caseTypeId'] = mainTypeItem['id'];
              groupItem['caseType'] = mainTypeItem['name'];
              groupItem['code'] = this.checkProperty(mainTypeItem, 'code');

              let caseType = { "name": mainTypeItem['name'], "id": mainTypeItem['id'] }
              this.caseTypesList.push(caseType)

              if (this.checkProperty(mainTypeItem, 'subTypes', 'length') > 0) {

                _.forEach(mainTypeItem['subTypes'], (subItem) => {
                  if (this.checkProperty(subItem, 'isCaseTypeSelected') != false) {
                    let sbItem = { "id": subItem['id'], "isSelected": true, "isCaseTypeSelected": true, "name": subItem['name'], "label": subItem['name'], "code": '' }
                    sbItem['code'] = this.checkProperty(subItem, 'code');

                    groupItem['subTypes'].push(sbItem);

                  }
                })

                // groupItem['subTypes'] = mainTypeItem['subTypes'].map((subItem)=>{
                //     return {"id":subItem['id'],"name":subItem['name'] ,"label":subItem['name']}
                // })
                if (this.checkProperty(groupItem, 'subTypes', 'length') > 0) {
                  this.petitionConfigList.push(groupItem);
                  this.petitionConfigListTemp.push(groupItem);
                }
              }
            }



          });




        });
    },
    submitPetitionAssign() {
      this.$validator.validateAll("permDeletForm").then((result) => {
        if (result) {
          let postData = {
            "userId": this.checkProperty(this.selectedItem, '_id'),
            "petitionerId": '',
          }
          if (this.checkProperty(this.selectedPetitionerDetails, '_id')) {
            postData['petitionerIds'] = this.checkProperty(this.selectedPetitionerDetails, '_id')
          }
          this.assigning = true;
          this.$store.dispatch("commonAction", { "data": postData, "path": "/perm/update-" })
            .then(response => {
              this.assigning = false;
              this.$modal.hide('assignPetitionerPopupModal')
            })
            .catch((error) => {
              this.assigning = false;
            })

        }
      })
    },
    getPetitioners() {
      let _self = this;
      let query = {
        "matcher": {
          "searchString": '',
          "statusIds": [],
          "countryIds": [],
          "stateIds": [],
          "locationIds": [],
          "createdDateRange": []
        },
        "sorting": { "path": "createdOn", "order": 1 },
        "page": 1,
        "perpage": 25,
        getMasterData: true
      }
      this.$store
        .dispatch("getList", { data: query, path: '/company/list' })
        .then(response => {

          _self.petitionersList = response.list;

          _.forEach(_self.petitionersList, (item) => {
            if (item && (_.has(item, 'name') && _.has(item, 'email'))) {
              if ((item['name'] && item['email'])) {
                item['name'] = item['name'] + ' (' + item['email'] + ')'
              }
            }
          })
        }).catch((err) => {
          this.petitionersList = [];

        })
    },
    showAssignPetitioner(item) {
      this.selectedPetitionerDetails = '';
      this.selectedItem = item;
      this.$modal.show('assignPetitionerPopupModal')
    },
    useCampanyAdress() {
      this.reloadAddress = false;
      if (this.useCompanyAdress && this.checkProperty(this.selected_roleID, 'id') == 6 && [3].indexOf(this.getUserRoleId) > -1) {
        this.countryDisable = true
        if (this.checkProperty(this.tenantDetails, 'address', 'countryId') == 231) {
          let address = {
            line1: this.checkProperty(this.tenantDetails, 'address', 'line1'),
            line2: this.checkProperty(this.tenantDetails, 'address', 'line2'),
            countryId: this.checkProperty(this.tenantDetails, 'address', 'countryId'),
            countryDetails: this.checkProperty(this.tenantDetails, 'address', 'countryDetails'),
            stateId: this.checkProperty(this.tenantDetails, 'address', 'stateId'),
            stateDetails: this.checkProperty(this.tenantDetails, 'address', 'stateDetails'),
            locationId: this.checkProperty(this.tenantDetails, 'address', 'locationId'),
            locationDetails: this.checkProperty(this.tenantDetails, 'address', 'locationDetails'),
            zipcode: this.checkProperty(this.tenantDetails, 'address', 'zipcode'),
            aptType: ''
          }
          this.new_user['address'] = _.cloneDeep(address);
        }
        else {
          let address = {
            line1: "",
            line2: "",
            countryId: 231,
            countryDetails: { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
            stateId: '',
            stateDetails: null,
            locationId: '',
            locationDetails: null,
            zipcode: '',
            aptType: ''
          }
          this.new_user['address'] = _.cloneDeep(address);
        }

        let new_user = _.cloneDeep(this.new_user)
        this.new_user = _.cloneDeep(new_user);
      }
      else {
        if (this.useCompanyAdress && [3].indexOf(this.getUserRoleId) > -1) {

          let address = {
            line1: this.checkProperty(this.tenantDetails, 'address', 'line1'),
            line2: this.checkProperty(this.tenantDetails, 'address', 'line2'),
            countryId: this.checkProperty(this.tenantDetails, 'address', 'countryId'),
            countryDetails: this.checkProperty(this.tenantDetails, 'address', 'countryDetails'),
            stateId: this.checkProperty(this.tenantDetails, 'address', 'stateId'),
            stateDetails: this.checkProperty(this.tenantDetails, 'address', 'stateDetails'),
            locationId: this.checkProperty(this.tenantDetails, 'address', 'locationId'),
            locationDetails: this.checkProperty(this.tenantDetails, 'address', 'locationDetails'),
            zipcode: this.checkProperty(this.tenantDetails, 'address', 'zipcode'),
            aptType: this.checkProperty(this.tenantDetails, 'address', 'aptType')
          }
          this.new_user['address'] = _.cloneDeep(address);

          let new_user = _.cloneDeep(this.new_user)
          this.new_user = _.cloneDeep(new_user);


        }
        else {

          this.new_user['address'] = {
            line1: "",
            line2: "",
            countryId: 231,
            countryDetails: { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" }
            , stateId: '',
            stateDetails: null,
            locationId: '',
            locationDetails: null,
            zipcode: '',
            aptType: ''
          }
          this.new_user = _.cloneDeep(this.new_user)



        }
      }
      setTimeout(() => {

        this.reloadAddress = true;
      });


    },
    getTenantDetails() {
      let postData = { tenantId: this.checkProperty(this.getUserData, 'tenantId') };
      this.$store.dispatch("commonAction", { "data": postData, "path": "/tenant/details" })
        .then((response) => {
          this.tenantDetails = response;
        })
        .catch((err) => {
          this.tenantDetails = null;
          //this.showToster({message:err,isError:true });
        })
    },
    editMe(item) {
      this.selectedUser = item;
      this.new_user = {
        // name: firstname + lastname,
        firstname: "",
        email: "",
        cpassword: '',
        password: '',
        roleId: '',
        phone: '',
        phoneCountryCode: '+91',
        lastname: '',
        phoneCountryCode: { 'countryCode': "US", "countryCallingCode": '+1' },
        address: {
          line1: "",
          line2: "",
          countryId: 231, countryDetails: { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" }
          , stateId: '',
          stateDetails: null,
          locationId: '',
          locationDetails: null,
          zipcode: '',
          aptType: ''
        },
        "homePhone": "",
      "homePhoneCountryCode": { countryCode: '', countryCallingCode: '' },
      "fax": "",
      "faxCountryCode": { countryCode: '', countryCallingCode: '' },
        usasDefaultAddress: false,
        defaultCaseAssignConfig: {
          subTypeIds: []
        },
        signDocs:[],
        subTypeDetails: [],
        manageCapRegistration: false,
      }

      //get user details_list_sec

      ///users/details
      let postData = { userId: "" };
      postData['userId'] = this.selectedUser['_id']

      this.$store
        .dispatch("commonAction", { "data": postData, "path": "/users/details" })
        .then(response => {
          // alert(JSON.stringify(this.petitionConfigList))
          if (this.checkProperty(response, 'defaultCaseAssignConfig') && this.checkProperty(response['defaultCaseAssignConfig'], 'subTypeIds', 'length') > 0) {

            this.new_user['subTypeDetails'] = [];
            _.forEach(this.petitionConfigList, (ite) => {

              if (ite['subTypes'] && ite['subTypes'].length > 0) {
                _.forEach(ite['subTypes'], (subType) => {
                  if (response['defaultCaseAssignConfig']['subTypeIds'].indexOf(subType['id']) > -1) {
                    this.new_user['subTypeDetails'].push(subType);
                  }

                })

              }

              // return response['defaultCaseAssignConfig']['subTypeIds'].indexOf(ite['id'])>-1
            })
          }
          if(this.checkProperty(this.selectedUser, "signDocs")){
            this.uploadOriginalDocument = response['signDocs']
           }

          if (this.checkProperty(response, "details", 'address')) {
            this.new_user['address'] = response['details']['address']

          } //&& this.isptnrAttorneySignByInternal==true removed this condition to enable for all tenants
          if ((this.checkProperty(response, "roleId") == 6 || this.checkProperty(response, "roleId") == 12)) {
            
            this.uploadOriginalDocument = response['signDocs']
            
           
          }
            
          if(this.checkProperty(response, "roleId") == 6 && this.checkProperty(response,'details', 'altEmailForForms')){
            this.altCheck = true
            this.altEmailForForms=  response['details']['altEmailForForms']

          }
          // "homePhone": "",
          // "homePhoneCountryCode": { countryCode: '', countryCallingCode: '' },
          // "fax": "",
          // "faxCountryCode": { countryCode: '', countryCallingCode: '' },
          if (this.checkProperty(response, "roleId") == 6) {
            if(!_.has(response['details'],'useOfficeAddress')){
              this.new_user = Object.assign(this.new_user, { "useOfficeAddress": false });
              this.selectedUser = Object.assign(this.selectedUser, { "useOfficeAddress": false });
            }
            else{
              this.new_user['useOfficeAddress'] = response['details']['useOfficeAddress']
              this.selectedUser['useOfficeAddress'] = response['details']['useOfficeAddress']
            }

            if(!_.has(response['details'],'homePhone')){
              this.new_user = Object.assign(this.new_user, { "homePhone": "","homePhoneCountryCode": { countryCode: '', countryCallingCode: '' } });
              this.selectedUser = Object.assign(this.selectedUser, { "homePhone": "","homePhoneCountryCode": { countryCode: '', countryCallingCode: '' } });
            }
            if(!_.has(response['details'],'fax')){
              this.new_user = Object.assign(this.new_user, { "fax": "","faxCountryCode": { countryCode: '', countryCallingCode: '' } });
              this.selectedUser = Object.assign(this.selectedUser, { "fax": "","faxCountryCode": { countryCode: '', countryCallingCode: '' } });
            }
          }
          this.new_user['manageCapRegistration'] = this.checkProperty(response, "manageCapRegistration")==true?true:false


          this.countryCode = "US";

          
          this.new_user['firstname'] = this.checkProperty(this.selectedUser, "firstName")
          this.new_user['middleName'] = this.checkProperty(this.selectedUser, "middleName")
          this.new_user['lastname'] = this.checkProperty(this.selectedUser, "lastName")
          this.new_user['email'] = this.checkProperty(this.selectedUser, "email")
          this.new_user['roleId'] = this.checkProperty(this.selectedUser, "roleId")
          this.new_user['phone'] = this.checkProperty(this.selectedUser, "phone")
          if(this.checkProperty(this.selectedUser, "branchListDetails")){
            this.selectedBranch = this.checkProperty(this.selectedUser, "branchListDetails")
          }
          this.selected_roleID = this.checkProperty(this.selectedUser, "roleDetails");
          if (this.checkProperty(this.selectedUser, "phoneCountryCode", 'countryCode')) {
            this.countryCode = (this.checkProperty(this.selectedUser, "phoneCountryCode", 'countryCode')).toUpperCase();
            this.new_user.phoneCountryCode = this.selectedUser['phoneCountryCode']
          }


          if (this.selectedUser['roleId'] == 6) {
            this.templicensingAuthorityStates = [];
            if(this.checkProperty(this.selectedUser, "homePhone")){
              this.new_user['homePhone'] = this.checkProperty(this.selectedUser, "homePhone")
            }
            if(this.checkProperty(this.selectedUser,  "homePhoneCountryCode", 'countryCode')){
              this.new_user.homePhoneCountryCode = this.selectedUser['homePhoneCountryCode']
            }
            if(this.checkProperty(this.selectedUser, "fax")){
              this.new_user['fax'] = this.checkProperty(this.selectedUser, "fax")
            }
            if(this.checkProperty(this.selectedUser,  "faxCountryCode", 'countryCode')){
              this.new_user.faxCountryCode = this.selectedUser['faxCountryCode']
            }
            if ((this.checkProperty(this.selectedUser, "representingStates", 'length') > 0)) {

              _.forEach(this.selectedUser['representingStates'], (item) => {
                let stateDetails = _.find(this.allUsstatesTemp, { "id": item['stateId'] });
                if (stateDetails) {
                  item = Object.assign(item, { 'stateDetails': stateDetails });
                  this.templicensingAuthorityStates.push(item);

                }

              })
              this.licensingAuthorityStates = _.cloneDeep(this.templicensingAuthorityStates);


            }
            if (this.licensingAuthorityStates.length <= 0) {
              this.addAttornyState();
            }
          }





          this.isPhoneValid = true;
          Object.assign(this.formerrors, {
            msg: ''
          });

          this.isUserEdit = true
          this.addNewUser = true;
          this.userCreating = false;
          this.$validator.reset();
          if (this.selectedUser['roleId'] == 6) {
            setTimeout(() => {
              this.new_user = _.cloneDeep(this.new_user);
            })
          }

          setTimeout(() => {
            this.isPhoneValid = true;
          }, 100);

          if (this.addNewUser) {
            
            this.$modal.show('inviteUserPopupModal');

          } else {
            this.$modal.hide('inviteUserPopupModal');
           
          }

        });

    },

    showDetails(item) {

      this.selectedUser = item;





      //templicensingAuthorityStates
      if (this.selectedUser['roleId'] == 6) {
        this.templicensingAuthorityStates = [];
        if ((this.checkProperty(this.selectedUser, "representingStates", 'length') > 0)) {
          _.forEach(this.selectedUser['representingStates'], (item) => {
            let stateDetails = _.find(this.allUsstatesTemp, { "id": item['stateId'] });
            if (stateDetails) {
              item = Object.assign(item, { 'stateDetails': stateDetails });
              this.templicensingAuthorityStates.push(item);

            }

          })


        }


      }
      this.lodedDetails = false;
      this.$modal.show('userDetailsPopupModal');
      if (this.checkProperty(this.selectedUser, '_id')) {
        let postData = { userId: "" };
        postData['userId'] = this.selectedUser['_id']

        this.$store.dispatch("commonAction", { "data": postData, "path": "/users/details" })
          .then(response => {
            let detai = response;
            let branchesList = [];
            let branches = '';
            if (_.has(detai, 'branchListDetails') && this.checkProperty(detai, 'branchListDetails') && this.checkProperty(detai, 'branchListDetails', 'length')>0) {
              _.forEach(detai['branchListDetails'], (it)=>{
                branchesList.push(it['name'])
              })
            }
            if(branchesList && branchesList.length>0){
              branches = branchesList.join(', ');
            }
            
            Object.assign(detai, { 'branchesList': branchesList, 'branches':branches });
            this.userDetails = detai;
            this.lodedDetails = true;
          }).catch((error) => {
            this.lodedDetails = false;
          })

      }


    },

    filterStates() {
      // this.allUsstates = response.list;
      //  this.allUsstatesTemp
      this.allUsstates = _.cloneDeep(this.allUsstatesTemp);

      let self = this;
      if (this.licensingAuthorityStates.length > 0) {
        let selectedStates = this.licensingAuthorityStates.map((item) => {

          return self.checkProperty(item, 'stateDetails', 'id')
        })

        this.allUsstates = _.filter(self.allUsstatesTemp, (state) => {
          return selectedStates.indexOf(state['id']) <= -1
        })



      }

    },
    openSetPasswordPopup(item) {
      this.selectedItem = item;
      this.formerrors.msg = null;
      this.newPassword = '';
      this.confPassword = '';
      this.updatingPassword = false;
      this.setPasswordErrorMsg = '';

      this.$validator.reset()
      this.SetPassword = true;
    },
    changePassword() {
      this.$validator.validateAll().then((result) => {
        this.setPasswordErrorMsg = '';
        if (result) {

          let self = this;
          let postData = {
            newPassword: self.newPassword,
            currentPassword: self.confPassword,
            userId: self.selectedItem['_id'],
            //email: this.getUserData.email,
            // roleId: this.getUserRoleId,

          };
          ///auth/change-password,
          this.updatingPassword = true;
          this.$store.dispatch("commonAction", { "data": postData, "path": "/auth/change-password" }).then((response) => {
            this.showToster({ message: response.message, isError: false });

            // this.$vs.notify({ text: response.data.message, });
            this.SetPassword = false;
            this.formerrors.msg = null;
            this.updatingPassword = false;

          }).catch((error) => {
            this.setPasswordErrorMsg = error;
            this.updatingPassword = false;
          })
        }
      });
    },
    addAttornyState() {

      this.licensingAuthorityStates.push(

        {
          stateDetails: null,
          barNumber: ''
        }
      )
    },
    removeAttornyState(index) {
      this.licensingAuthorityStates.splice(index, 1);
      this.filterStates();

    },
    clearCheck(val){
      if(val == true){  
      }
      else{
       this.altEmailForForms="" 
      }
      this.errorMsg='';
      this.disableSubmitBtn = false;
    },
    roleChanged(role) {
      this.altCheck = false
       this.altEmailForForms=""

      this.uploadOriginalDocument=[];
      if (this.checkProperty(this.selected_roleID, 'id') == 6) {
        this.countryDisable = true;
      }
      if (!this.isUserEdit) {
        this.useCampanyAdress()
      }

      this.selected_roleID = role;
      this.licensingAuthorityStates = [];
      this.addAttornyState();
      this.filterStates()
      this.barNumber = '';
      if(this.checkProperty(this.selected_roleID, 'id') != 6){
        this.new_user['homePhone']= "";
        this.new_user['homePhoneCountryCode']= { countryCode: '', countryCallingCode: '' };
        this.new_user['fax']= "";
        this.new_user['faxCountryCode']= { countryCode: '', countryCallingCode: '' };
      }
      if ((this.checkProperty(this.selected_roleID, 'id') == 6)) {
        this.new_user = Object.assign(this.new_user, { "useOfficeAddress": null });
        setTimeout(() => {
          this.new_user = _.cloneDeep(this.new_user);
        })

      }
      if ((this.checkProperty(this.selected_roleID, 'id') != 4)) {
        this.branchList = this.branchTempList;
        if(this.checkProperty(this.selectedUser, "branchListDetails")){
          this.selectedBranch = this.checkProperty(this.selectedUser, "branchListDetails")
        }
        
      } else {
        //this.selectedUser
        if(this.checkProperty(this.selectedUser, "branchListDetails")){
          this.selectedBranch = this.checkProperty(this.selectedUser, "branchListDetails")
        }
      }
      this.$validator.reset();
    },
    sortMe(sort_key = '') {

      this.page =1;

      if (sort_key != '') {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1
        this.sortKey = {};
        this.sortKey = { "path": sort_key, "order": this.sortKeys[sort_key] }

        this.getUsersList();
      }
    },
    resend(item) {
      this.selectedItem = item;
      let obj = { "email": this.selectedItem['email'] };
      if (this.getTenantId) {
        obj = Object.assign(obj, { "tenantId": this.getTenantId })
      }
      this.$store
        .dispatch("resend", obj)
        .then(response => {
          //alert(JSON.stringify(response.data.message))
          if (response.error) {

            this.showToster({ message: response.error.message, isError: true })
          } else {
            this.showToster({ message: response.data.message, isError: false })

          }

        })
        .catch((err) => {
          this.showToster({ message: err, isError: true });

        });

    },
    getBranchList() {

      let postData = {
        "filters": { "title": "", "createdDateRange": [], "statusList": [], "activeList": [] },
        //"getMasterData":true,
        "page": 1,
        "perpage": 250000,
        "sorting": { "path": "createdOn", "order": -1 }
      };
      this.$store.dispatch("getList", { "data": postData, "path": "/branch/list" })
        .then((res) => {
          let list = res.list
          this.branchList = list;
          this.branchTempList = list;


          if (this.branchList.length > 0) {
            let userData = this.getUserData;

            if (this.getUserRoleId == 4 && _.has(userData, "branchId")) {


              let branchObj = _.find(this.branchList, { "_id": userData['branchId'] });
              if(branchObj){
                this.selectedBranch.push(branchObj)
              }
              //branchDetails
            } else {
              this.selectedBranch.push(this.branchList[0]);

            }




          }

          //alert(JSON.stringify(res));
        })
        .catch((err) => {
          this.branchList = [];
        })
    },
    updatePhone(item) {
      this.isPhoneValid = true

      if (item.isValid) {

        this.new_user.phoneCountryCode = { countryCode: item.countryCode, countryCallingCode: item.countryCallingCode };
        this.new_user.phone = item.nationalNumber;

      } else {
        this.isPhoneValid = false;
      }
    },


    getUsersList(callFromSerch = false) {
      this.callFromSerch = callFromSerch;
      this.contentLoaded = false;
      this.updateLoading(true);
      if (this.callFromSerch) {

        this.users = [];
      }
      let matcher = {
        roleIds: this.final_filter_roleIds,
        title: '',
        searchString: '',
        statusIds: this.final_selected_statusids,
        stateIds: this.final_selected_states,
        locationIds: this.final_selected_locations,
        createdDateRange: this.date_range,
        page: this.page,
        perpage: this.perpage
      };
      if(this.searchtxt){
        matcher['title'] = this.searchtxt.trim();
        matcher['searchString'] = this.searchtxt.trim()
      }

      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        matcher["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"]
        ];
      }
      if (this.filterBranch.length > 0) {
        matcher = Object.assign(matcher, { "branchIds": this.filterBranch.map((item) => item['_id']) })
      }
      let query = {};
      query['page'] = this.page;
      query['perpage'] = this.perpage;
      query['matcher'] = matcher;
      query['sorting'] = this.sortKey;
      //alert( JSON.stringify(query['sorting']))

      this.$store
        .dispatch("getList", { data: query, path: '/users/list' })
        .then(response => {
          let fileteredBranch = [];
          if(this.filterBranch && this.checkProperty(this.filterBranch, 'length')>0){
            _.forEach(this.filterBranch, (bran)=>{
              fileteredBranch.push(bran['name'])
            })
          }
          this.updateLoading(false);
          let tempList = response.list;
          let selectedFilter = ''
          if (tempList && this.checkProperty(tempList, 'length') > 0) {
            _.forEach(tempList, (item) => {
              let branchesList = [];
              let tempBranchList = [];
              let branches = '';
              let tempBranchNames = '';
              if (_.has(item, 'branchListDetails') && this.checkProperty(item, 'branchListDetails') && this.checkProperty(item, 'branchListDetails', 'length')>0) {
                _.forEach(item['branchListDetails'], (it)=>{
                  tempBranchList.push(it['name'])
                })
              }
              if(fileteredBranch && fileteredBranch.length>0){
                selectedFilter = fileteredBranch[0]
              }
              if(tempBranchList && tempBranchList.length>0){
                if(selectedFilter){
                  let bindex = tempBranchList.indexOf(selectedFilter);
                  if (bindex !== -1) {
                    tempBranchList.splice(bindex, 1); // Remove the element from its current position
                    tempBranchList.unshift(selectedFilter);   // Add it to the beginning of the array
                  }
                }
                tempBranchNames = tempBranchList.join(', ');
              }
              
              Object.assign(item, { 'branchesList': tempBranchList, 'branches':tempBranchNames });
              branchesList = [];
              tempBranchList = [];
            })
            this.users = tempList;
          }
          //this.users = response.list;
          this.contentLoaded = true;
          this.totalCount = this.checkProperty(response, 'totalCount')
          this.totalpages = Math.ceil(response.totalCount / this.perpage);

          //alert(this.perpage);
        }).catch((err) => {
          this.updateLoading(false);
          this.users = [];


        })
    },
    saveuser(replaceBranchManager = false) {
      this.userConformErrorMsg ='';
      this.userConformMsg = '';
      this.userConform =false;
      this.conformUserId ='';
      this.$validator.validateAll().then(result => {

        if (result && this.isPhoneValid) {

          let self = this;


          let firstname = this.new_user['firstname'].trim();
          let lastname = this.new_user['lastname'].trim();

          this.new_user = Object.assign(this.new_user, { name: firstname + ' ' + lastname });
          this.new_user = Object.assign(this.new_user, { "firstName": firstname });
          this.new_user = Object.assign(this.new_user, { "lastName": lastname });

          this.new_user['roleId'] = this.selected_roleID['id']; 
          //selectedBranch
          //getUserRoleId
          this.new_user = Object.assign(this.new_user, { "branchIds": [] });
          if ([3, 4].indexOf(this.getUserRoleId) > -1 && this.selectedBranch && this.checkProperty(this.selectedBranch, "length")>0) {
            this.new_user['branchIds'] = this.selectedBranch.map((item) => item._id);
            // this.new_user = Object.assign(this.new_user, { "branchId": this.selectedBranch['_id'] })
          }
          if (this.new_user['roleId'] == 1) {
            this.new_user = Object.assign(this.new_user, { "apiKey": 'FV$HSE@JUGUUGU$J5L@HE' })
          }
          if([6].indexOf(this.new_user['roleId'])<=-1){
            this.new_user['homePhone']= "";
            this.new_user['homePhoneCountryCode']= { countryCode: '', countryCallingCode: '' };
            this.new_user['fax']= "";
            this.new_user['faxCountryCode']= { countryCode: '', countryCallingCode: '' };
          }
          let postData = _.cloneDeep(this.new_user);

          if (this.new_user['roleId'] == 6) {
            let representingStateIds = self.licensingAuthorityStates.map((item) => {
              return { 'stateId': item.stateDetails.id, "barNumber": item.barNumber }
            })
            
            // let representingStateIds = self.licensingAuthorityStates[0]['stateDetails'].map((item)=>{
            //    return {'stateId':item.id ,"barNumber":self.barNumber}
            //    })

            //alert(JSON.stringify(representingStateIds))
            postData = Object.assign(postData, { "representingStates": representingStateIds })
          }  //&& this.isptnrAttorneySignByInternal==true
          if((this.new_user['roleId'] == 6 || this.new_user['roleId'] == 12 )){
             
             // this.new_user = Object.assign(this.new_user, { "signDocs": this.uploadOriginalDocument })
              postData =Object.assign(postData,{"signDocs":this.uploadOriginalDocument})
            }
            if(this.new_user['roleId'] == 6 && this.altCheck){
              postData = Object.assign(postData, { "altEmailForForms": this.altEmailForForms })
            }
          postData['defaultCaseAssignConfig']['subTypeIds'] = [];
          if (this.new_user.subTypeDetails.length > 0 && [1, 2, 3].indexOf(this.checkProperty(this.selected_roleID, 'id')) <= -1) {
            postData['defaultCaseAssignConfig']['subTypeIds'] = _.map(this.new_user.subTypeDetails, (item) => item.id)

          }


          //{{licensingAuthorityStates}} --{{barNumber}} 
          this.userCreating = true;
          let path = "/users/register";
          if (this.isUserEdit) {
            path = "users/update";
            postData = Object.assign(postData, { 'userId': '' });
            postData['userId'] = this.selectedUser['_id']


          }
          if (replaceBranchManager == true) {
            postData = Object.assign(postData, { 'replaceBranchManager': true });
          }
          postData = Object.assign(postData,{ "checkDeleteOrInactive": true}) 
          this.$store.dispatch("commonActionWithErrorData", { data: postData, path: path }).then((response) => {
            this.showToster({ message: response.message, isError: false });
            this.userCreating = false;
            this.isUserEdit = false;
            this.replaceBranchManagerConformpopUp = false;
            this.conformMsg = '';
            this.inviteUserPopupshow(false);
            this.getUsersList();


          })
            .catch((error) => {

              this.userCreating = false;
             // alert(JSON.stringify(error));
              // alert(this.checkProperty(error ,'code'));
              if(this.checkProperty(error, 'error','code') == 'ACTIVATE_USER_ACCOUNT'){
                this.userCreating = false;
                this.isUserEdit = false;
                this.addNewUser = false;
                this.loading =false;
                this.userConformMsg = this.checkProperty(error,'msg');
                this.userConform =true;
                this.conformUserId = this.checkProperty(error, '_id');


                

              }else if (this.checkProperty(error, 'code') == 'EXISTS_BRANCH_MANAGER') {
                this.replaceBranchManagerConformpopUp = true;
                this.conformMsg = error['message'];
              } else {
                Object.assign(this.formerrors, { msg: error['message'] });
              }

            });


        }
      });
    },
    inviteUserPopupshow(action = true) {
      this.userConformErrorMsg ='';
      this.userConformMsg = '';
      this.userConform =false;
      this.conformUserId ='';
      this.conformMsg = '';
      this.altCheck = false;
      this.altEmailForForms = '';
      this.errorMsg='';
      //  if((this.branchList.length<=0) && [3,4].indexOf(this.getUserRoleId)>-1 ){
      //      this.showToster({message:"Create a Branch",isError:true });
      //      this.$router.push("/branch-create");

      //   }
  
        this.uploadMainDocuments=[]
      
      this.countryDisable = false;
      this.useCompanyAdress = false;
      this.selectedUser = null;
      this.countryCode = "US";
      this.isUserEdit = false;
      this.licensingAuthorityStates = [];
      this.addNewUser = false;
      this.userCreating = false;
      this.new_user = {
        // name: firstname + lastname,
        firstname: "",
        email: "",
        cpassword: '',
        password: '',
        roleId: '',
        phone: '',
        phoneCountryCode: '+1',
        lastname: '',
        phoneCountryCode: { 'countryCode': "US", "countryCallingCode": '+1' },
        "homePhone": "",
        "homePhoneCountryCode": { countryCode: '', countryCallingCode: '' },
        "fax": "",
        "faxCountryCode": { countryCode: '', countryCallingCode: '' },
        address: {
          line1: "",
          line2: "",
          countryId: 231, countryDetails: { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" }
          , stateId: '',
          stateDetails: null,
          locationId: '',
          locationDetails: null,
          zipcode: '',
          aptType: ''
        },
        signDocs:[],
        usasDefaultAddress: false,
        defaultCaseAssignConfig: {
          subTypeIds: []
        },
        subTypeDetails: [],
        manageCapRegistration: false,
      }
      // if([3,4].indexOf(this.getUserRoleId)>-1 ){
      // this.new_user['address']= {
      //      line1:this.checkProperty(this.tenantDetails,'address','line1')  , 
      //      line2:this.checkProperty(this.tenantDetails,'address','line2') ,
      //      countryId:this.checkProperty(this.tenantDetails,'address','countryId') ,
      //      countryDetails:this.checkProperty(this.tenantDetails,'address','countryDetails'),
      //      stateId:this.checkProperty(this.tenantDetails,'address','stateId'),
      //      stateDetails:this.checkProperty(this.tenantDetails,'address','stateDetails'),
      //      locationId:this.checkProperty(this.tenantDetails,'address','locationId'),
      //      locationDetails:this.checkProperty(this.tenantDetails,'address','locationDetails') ,
      //      zipcode:this.checkProperty(this.tenantDetails,'address','zipcode'),
      //      aptType:''
      //   }
      //   this.new_user=_.cloneDeep(this.new_user)
      // }
      this.addNewUser = action;

      this.isPhoneValid = true;
      Object.assign(this.formerrors, {
        msg: ''
      });

      this.selected_roleID = null;
      if ((this.branchList.length > 1)) {
        this.selectedBranch = [];

      }
      this.$validator.reset();

      setTimeout(() => {
        this.isPhoneValid = true;
      }, 100);

      if (this.addNewUser) {
        this.$modal.show('inviteUserPopupModal');
      } else {
        this.$modal.hide('inviteUserPopupModal');
      }



    },
    get_statusids() {
      let query = {
        category: "user_status", //user_status
        page: 1,
        perpage: 1000,
      };

      this.$store.dispatch("getMasterData", query).then(response => {
        this.all_statusids = response.list;
        //alert(JSON.stringify(this.all_statusids));
        // this.all_statusids = _.filter( this.all_statusids ,(item)=>{
        //     return [1,2,3].indexOf(item['id']) >-1
        // })
        //alert(JSON.stringify(this.all_statusids));

      });
    },

    changed_new_user_state() {

      this.getLocation();
    },
    //get all_states
    get_all_states(country_code) {
      let item = {
        matcher: {
          countryId: country_code
        },
        page: 1,
        perpage: 1000,
        category: "states",
        // tenantId: tenantId,
      };
      this.$store.dispatch("getMasterData", item).then(response => {
        this.all_states = response.list;
      });
    },
    getLocation() {
      var obj = {
        stateId: this.new_user.address.stateId,
        countryId: this.new_user.address.countryId
      };

      this.$store.dispatch("getlocations", obj).then(response => {
        this.locations = response;

      });
    },
    getvisatypes() {
      this.$store.dispatch("getvisatypes").then(response => {
        this.visatypes = response;
      });
    },
    getvisasubtypes() {
      this.$store.dispatch("getvisasubtypes").then(response => {
        this.visasubtypes = response;
      });
    },
    getAllLocations() {
      Object.assign(this.query, {
        countryId: this.country_code,
        stateId: this.final_selected_states //3922
      });

      this.$store.dispatch("getlocations", this.query).then(response => {
        this.all_locations = response;
      });
    },
    changedState: function () {
      if (this.seleted_states.length > 0) {
        this.final_selected_states = [];
        for (let ind = 0; ind < this.seleted_states.length; ind++) {
          let current_index = this.seleted_states[ind];
          this.final_selected_states.push(current_index["id"]);
        }
        this.getAllLocations();
      } else {
        this.final_selected_states = [];
        this.final_selected_locations = [];
      }
    },
    set_filter: function () {
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      this.final_selected_statusids = [];
      if (this.selected_statusids.length > 0) {
        this.final_selected_statusids = [];
        for (let ind = 0; ind < this.selected_statusids.length; ind++) {
          let current_index = this.selected_statusids[ind];
          this.final_selected_statusids.push(current_index["id"]);
        }
      }

      if (this.filter_roleIds.length > 0) {
        this.final_filter_roleIds = [];
        for (let ind = 0; ind < this.filter_roleIds.length; ind++) {
          let current_index = this.filter_roleIds[ind];
          this.final_filter_roleIds.push(current_index["id"]);
        }
      } else {
        this.final_filter_roleIds = [];
      }

      //states
      this.final_selected_states = [];
      if (this.seleted_states.length > 0) {
        this.final_selected_states = [];
        for (let ind = 0; ind < this.seleted_states.length; ind++) {
          let current_index = this.seleted_states[ind];
          this.final_selected_states.push(current_index["id"]);
        }
      }

      this.final_selected_locations = [];
      if (this.seleted_locations.length > 0) {
        for (let ind = 0; ind < this.seleted_locations.length; ind++) {
          let current_index = this.seleted_locations[ind];
          this.final_selected_locations.push(current_index["id"]);
        }
      }
      this.page =1;
      this.getUsersList(true);
    },
    clear_filter: function () {
      this.filterBranch = [];
      this.searchtxt = '';
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      this.selected_statusids = [];
      this.final_selected_statusids = [];
      this.seleted_states = [];
      this.final_selected_states = [];
      this.seleted_locations = [];
      this.final_selected_locations = [];
      this.date = "";
      this.date_range = [];
      this.final_filter_roleIds = [];
      this.selected_createdDateRange["startDate"] = "";
      this.selected_createdDateRange["endDate"] = "";
      this.selected_statusids = [];
      this.filter_roleIds = [];
      this.getUsersList();
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getUsersList();
    },
    get_user_roles: function () {
      let postdata = "user_roles";
      this.$store
        .dispatch("getmastedata", postdata)
        .then(response => {
          //alert(JSON.stringify(response));
          let allowRoles = [];
          let loginRoleId = this.getUserRoleId;
          if (loginRoleId == 1) {

            allowRoles = [1, 2];
          }
          if (loginRoleId == 3) {

            allowRoles = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
            if (this.getTenantTypeId == 1) {
              allowRoles = [4, 5, 6, 7, 8, 9, 10, 11, 13, 14];
            }

          }
          if (loginRoleId == 4) {

            allowRoles = [5, 6, 7, 8, 9, 10, 11, 12, 13];
            if (this.getTenantTypeId == 1) {
              allowRoles = [5, 6, 7, 8, 9, 10, 11, 13];
            }
          }
          if (!response.error) {
            if (response.length > 0 && allowRoles.length > 0) {
              for (let k = 0; k < response.length; k++) {
                let item = response[k];
                if (allowRoles.indexOf(item['id']) > -1) {
                  this.all_userroles.push(response[k])

                }

              }

            }

          }


        });
    },


  },
  mounted() {
    if ([50, 51].indexOf(this.getUserRoleId) > -1) {
      this.$router.push('/dashboard')
    }
    this.getGlobalConfigDetails();
    this.getPetitioners();
    if ([3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 50].indexOf(this.getUserRoleId) > -1) {
      this.getTenantDetails();
    }


    let item = {
      matcher: {
        countryId: 231
      },
      page: 1,
      perpage: 1000,
      category: "states",

    };
    this.$store.dispatch("getMasterData", item).then(response => {
      let list = response.list
      this.allUsstates = list;
      this.allUsstatesTemp = _.cloneDeep(this.allUsstates);
    });


    this.sortKey = { "path": "createdOn", "order": -1 };
    this.sortKeys = {

      createdOn: -1,
      invitedByName: 1,
      updatedOn: 1,
      name: 1,
      email: 1,
      phone: 1,
      statusName: 1,
      roleName: 1
    };

    this.selected_statusids = [];
    this.final_selected_statusids = [];
    this.seleted_states = [];
    this.final_selected_states = [];

    this.seleted_locations = [];
    this.final_selected_locations = [];
    this.get_statusids();
    this.get_all_states(this.country_code);
    this.getvisatypes();
    this.getvisasubtypes();
    this.getUsersList();
    this.get_user_roles();
    //if([1,2,3,4].indexOf(this.getUserRoleId) <= -1 ){
    this.getBranchList();


    //  }

    let matcher = {};
    let postData = {
      matcher: matcher,
      page: 1,
      perpage: 1000,
      category: 'countries',

    };
    this.$store.dispatch("getMasterData", postData)
      .then((res) => {
        this.countries = res['list']
      })

    this.getPetitionConfigList();

  }
};
</script>
